// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  infiniteQueryOptions,
  queryOptions,
  type UseMutationOptions,
} from "@tanstack/react-query"

import { client } from "../client.gen"
import {
  acquireTeamReviewLock,
  addLateAuthor,
  addLtiDeployment,
  addTeamMember,
  adjustJoinCode,
  adjustSectionJoinCode,
  adminEnrollMockStudents,
  archiveSection,
  assignLateJoiner,
  assignLateJoinerTeam,
  bulkAddTeamMembers,
  bulkEnrollUsers,
  bulkRemoveTeamMembers,
  bulkUnenrollUsers,
  clearJoinCode,
  clearSectionJoinCode,
  closeAssignment,
  confirmSignup,
  createApiKey,
  createAssignment,
  createCourse,
  createLtiClientConfig,
  createLtiIssuer,
  createLtiToolKey,
  createProject,
  createRubric,
  createRubricItem,
  createRubricItemOption,
  createRubricV2,
  createSection,
  createTeam,
  createTeamGroup,
  createUser,
  deleteApiKey,
  deleteAssignment,
  deleteCourse,
  deleteLtiClientConfig,
  deleteLtiIssuer,
  deleteLtiToolKey,
  deleteProject,
  deleteRubric,
  deleteRubricItem,
  deleteRubricItemOption,
  deleteSubmittedReview,
  deleteTeam,
  deleteTeamGroup,
  deleteUser,
  enrollUser,
  exportAssignmentAllocations,
  exportAssignmentReviews,
  exportAssignmentScores,
  exportGradebook,
  exportRoster,
  generateJoinCode,
  generateSectionJoinCode,
  getAssignment,
  getAssignmentScoringConfig,
  getAssignmentSummary,
  getCourse,
  getCourseSummary,
  getCurrentUser,
  getInstructorDashboard,
  getJoinCode,
  getJwks,
  getLtiClientConfig,
  getLtiIssuer,
  getLtiLaunchContext,
  getLtiToolKey,
  getMyPublishedAssignmentScore,
  getMyPublishedScoresForCourse,
  getProject,
  getProjectReviewSummary,
  getPublishedAssignmentScore,
  getReviewDraft,
  getRevieweeScore,
  getRevieweeTeamScore,
  getReviewerParticipation,
  getReviewerTeamParticipation,
  getRubric,
  getSection,
  getSectionJoinCode,
  getStudentDashboard,
  getTeamReview,
  getUser,
  healthCheck,
  importRoster,
  joinCourse,
  listAllocations,
  listAssignments,
  listCoursePublishedScores,
  listCourses,
  listEnrollments,
  listLtiClientConfigs,
  listLtiDeployments,
  listLtiIssuers,
  listLtiToolKeys,
  listMembers,
  listMyAllocations,
  listMyReceivedReviews,
  listMyWrittenReviews,
  listProjects,
  listPublishedAssignmentScores,
  listReviews,
  listRubricItemOptions,
  listRubricItems,
  listRubrics,
  listRubricsV2,
  listSectionAssignments,
  listSectionEnrollments,
  listSectionProjects,
  listSections,
  listTeamAllocations,
  listTeamGroups,
  listTeams,
  listUserRubricTemplates,
  login,
  logout,
  ltiDeepLinkPayload,
  ltiDynamicRegistration,
  ltiGradeSync,
  ltiLaunch,
  ltiLoginGet,
  ltiLoginPost,
  ltiRosterSync,
  openAssignment,
  type Options,
  previewAssignmentScores,
  publishAssignment,
  readRoot,
  recommendExtraTargets,
  recommendExtraTargetsForReviewerTeam,
  releaseTeamReviewLock,
  removeLtiDeployment,
  removeTeamMember,
  renameSection,
  reorderRubricItemOptions,
  reorderRubricItems,
  replaceRubric,
  resetPassword,
  rotateJoinCode,
  rotateSectionJoinCode,
  saveReviewDraft,
  saveTeamReviewDraft,
  signup,
  submitReview,
  submitStaffReview,
  submitTeamReview,
  unenrollUser,
  unsubmitTeamReview,
  updateAssignment,
  updateAssignmentScoringConfig,
  updateCourse,
  updateEnrollment,
  updateLtiClientConfig,
  updateLtiIssuer,
  updateLtiToolKey,
  updateProject,
  updateRubric,
  updateRubricItem,
  updateRubricItemOption,
  updateTeam,
  updateTeamGroup,
  updateUser,
} from "../sdk.gen"
import type {
  AcquireTeamReviewLockData,
  AcquireTeamReviewLockError,
  AcquireTeamReviewLockResponse,
  AddLateAuthorData,
  AddLateAuthorError,
  AddLateAuthorResponse,
  AddLtiDeploymentData,
  AddLtiDeploymentError,
  AddLtiDeploymentResponse,
  AddTeamMemberData,
  AddTeamMemberError,
  AddTeamMemberResponse,
  AdjustJoinCodeData,
  AdjustJoinCodeError,
  AdjustJoinCodeResponse,
  AdjustSectionJoinCodeData,
  AdjustSectionJoinCodeError,
  AdjustSectionJoinCodeResponse,
  AdminEnrollMockStudentsData,
  AdminEnrollMockStudentsError,
  AdminEnrollMockStudentsResponse,
  ArchiveSectionData,
  ArchiveSectionError,
  ArchiveSectionResponse,
  AssignLateJoinerData,
  AssignLateJoinerError,
  AssignLateJoinerResponse,
  AssignLateJoinerTeamData,
  AssignLateJoinerTeamError,
  AssignLateJoinerTeamResponse,
  BulkAddTeamMembersData,
  BulkAddTeamMembersError,
  BulkAddTeamMembersResponse,
  BulkEnrollUsersData,
  BulkEnrollUsersError,
  BulkEnrollUsersResponse,
  BulkRemoveTeamMembersData,
  BulkRemoveTeamMembersError,
  BulkRemoveTeamMembersResponse,
  BulkUnenrollUsersData,
  BulkUnenrollUsersError,
  BulkUnenrollUsersResponse,
  ClearJoinCodeData,
  ClearJoinCodeError,
  ClearJoinCodeResponse,
  ClearSectionJoinCodeData,
  ClearSectionJoinCodeError,
  ClearSectionJoinCodeResponse,
  CloseAssignmentData,
  CloseAssignmentError,
  CloseAssignmentResponse,
  ConfirmSignupData,
  ConfirmSignupError,
  CreateApiKeyData,
  CreateApiKeyError,
  CreateApiKeyResponse,
  CreateAssignmentData,
  CreateAssignmentError,
  CreateAssignmentResponse,
  CreateCourseData,
  CreateCourseError,
  CreateCourseResponse,
  CreateLtiClientConfigData,
  CreateLtiClientConfigError,
  CreateLtiClientConfigResponse,
  CreateLtiIssuerData,
  CreateLtiIssuerError,
  CreateLtiIssuerResponse,
  CreateLtiToolKeyData,
  CreateLtiToolKeyError,
  CreateLtiToolKeyResponse,
  CreateProjectData,
  CreateProjectError,
  CreateProjectResponse,
  CreateRubricData,
  CreateRubricError,
  CreateRubricItemData,
  CreateRubricItemError,
  CreateRubricItemOptionData,
  CreateRubricItemOptionError,
  CreateRubricItemOptionResponse,
  CreateRubricItemResponse,
  CreateRubricResponse,
  CreateRubricV2Data,
  CreateRubricV2Error,
  CreateRubricV2Response,
  CreateSectionData,
  CreateSectionError,
  CreateSectionResponse,
  CreateTeamData,
  CreateTeamError,
  CreateTeamGroupData,
  CreateTeamGroupError,
  CreateTeamGroupResponse,
  CreateTeamResponse,
  CreateUserData,
  CreateUserError,
  CreateUserResponse,
  DeleteApiKeyData,
  DeleteApiKeyError,
  DeleteApiKeyResponse,
  DeleteAssignmentData,
  DeleteAssignmentError,
  DeleteAssignmentResponse,
  DeleteCourseData,
  DeleteCourseError,
  DeleteCourseResponse,
  DeleteLtiClientConfigData,
  DeleteLtiClientConfigError,
  DeleteLtiClientConfigResponse,
  DeleteLtiIssuerData,
  DeleteLtiIssuerError,
  DeleteLtiIssuerResponse,
  DeleteLtiToolKeyData,
  DeleteLtiToolKeyError,
  DeleteLtiToolKeyResponse,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectResponse,
  DeleteRubricData,
  DeleteRubricError,
  DeleteRubricItemData,
  DeleteRubricItemError,
  DeleteRubricItemOptionData,
  DeleteRubricItemOptionError,
  DeleteRubricItemOptionResponse,
  DeleteRubricItemResponse,
  DeleteRubricResponse,
  DeleteSubmittedReviewData,
  DeleteSubmittedReviewError,
  DeleteSubmittedReviewResponse,
  DeleteTeamData,
  DeleteTeamError,
  DeleteTeamGroupData,
  DeleteTeamGroupError,
  DeleteTeamGroupResponse,
  DeleteTeamResponse,
  DeleteUserData,
  DeleteUserError,
  DeleteUserResponse,
  EnrollUserData,
  EnrollUserError,
  EnrollUserResponse,
  ExportAssignmentAllocationsData,
  ExportAssignmentAllocationsError,
  ExportAssignmentReviewsData,
  ExportAssignmentReviewsError,
  ExportAssignmentScoresData,
  ExportAssignmentScoresError,
  ExportGradebookData,
  ExportGradebookError,
  ExportRosterData,
  ExportRosterError,
  GenerateJoinCodeData,
  GenerateJoinCodeError,
  GenerateJoinCodeResponse,
  GenerateSectionJoinCodeData,
  GenerateSectionJoinCodeError,
  GenerateSectionJoinCodeResponse,
  GetAssignmentData,
  GetAssignmentError,
  GetAssignmentResponse,
  GetAssignmentScoringConfigData,
  GetAssignmentScoringConfigError,
  GetAssignmentScoringConfigResponse,
  GetAssignmentSummaryData,
  GetAssignmentSummaryError,
  GetAssignmentSummaryResponse,
  GetCourseData,
  GetCourseError,
  GetCourseResponse,
  GetCourseSummaryData,
  GetCourseSummaryError,
  GetCourseSummaryResponse,
  GetCurrentUserData,
  GetCurrentUserError,
  GetCurrentUserResponse,
  GetInstructorDashboardData,
  GetInstructorDashboardError,
  GetInstructorDashboardResponse,
  GetJoinCodeData,
  GetJoinCodeError,
  GetJoinCodeResponse,
  GetJwksData,
  GetJwksResponse,
  GetLtiClientConfigData,
  GetLtiClientConfigError,
  GetLtiClientConfigResponse,
  GetLtiIssuerData,
  GetLtiIssuerError,
  GetLtiIssuerResponse,
  GetLtiLaunchContextData,
  GetLtiLaunchContextError,
  GetLtiLaunchContextResponse,
  GetLtiToolKeyData,
  GetLtiToolKeyError,
  GetLtiToolKeyResponse,
  GetMyPublishedAssignmentScoreData,
  GetMyPublishedAssignmentScoreError,
  GetMyPublishedAssignmentScoreResponse,
  GetMyPublishedScoresForCourseData,
  GetMyPublishedScoresForCourseError,
  GetMyPublishedScoresForCourseResponse,
  GetProjectData,
  GetProjectError,
  GetProjectResponse,
  GetProjectReviewSummaryData,
  GetProjectReviewSummaryError,
  GetProjectReviewSummaryResponse,
  GetPublishedAssignmentScoreData,
  GetPublishedAssignmentScoreError,
  GetPublishedAssignmentScoreResponse,
  GetReviewDraftData,
  GetReviewDraftError,
  GetReviewDraftResponse,
  GetRevieweeScoreData,
  GetRevieweeScoreError,
  GetRevieweeScoreResponse,
  GetRevieweeTeamScoreData,
  GetRevieweeTeamScoreError,
  GetRevieweeTeamScoreResponse,
  GetReviewerParticipationData,
  GetReviewerParticipationError,
  GetReviewerParticipationResponse,
  GetReviewerTeamParticipationData,
  GetReviewerTeamParticipationError,
  GetReviewerTeamParticipationResponse,
  GetRubricData,
  GetRubricError,
  GetRubricResponse,
  GetSectionData,
  GetSectionError,
  GetSectionJoinCodeData,
  GetSectionJoinCodeError,
  GetSectionJoinCodeResponse,
  GetSectionResponse,
  GetStudentDashboardData,
  GetStudentDashboardError,
  GetStudentDashboardResponse,
  GetTeamReviewData,
  GetTeamReviewError,
  GetTeamReviewResponse,
  GetUserData,
  GetUserError,
  GetUserResponse,
  HealthCheckData,
  HealthCheckResponse,
  ImportRosterData,
  ImportRosterError,
  ImportRosterResponse,
  JoinCourseData,
  JoinCourseError,
  JoinCourseResponse,
  ListAllocationsData,
  ListAllocationsError,
  ListAllocationsResponse,
  ListAssignmentsData,
  ListAssignmentsError,
  ListAssignmentsResponse,
  ListCoursePublishedScoresData,
  ListCoursePublishedScoresError,
  ListCoursePublishedScoresResponse,
  ListCoursesData,
  ListCoursesError,
  ListCoursesResponse,
  ListEnrollmentsData,
  ListEnrollmentsError,
  ListEnrollmentsResponse,
  ListLtiClientConfigsData,
  ListLtiClientConfigsError,
  ListLtiClientConfigsResponse,
  ListLtiDeploymentsData,
  ListLtiDeploymentsError,
  ListLtiDeploymentsResponse,
  ListLtiIssuersData,
  ListLtiIssuersError,
  ListLtiIssuersResponse,
  ListLtiToolKeysData,
  ListLtiToolKeysError,
  ListLtiToolKeysResponse,
  ListMembersData,
  ListMembersError,
  ListMembersResponse,
  ListMyAllocationsData,
  ListMyAllocationsError,
  ListMyAllocationsResponse,
  ListMyReceivedReviewsData,
  ListMyReceivedReviewsError,
  ListMyReceivedReviewsResponse,
  ListMyWrittenReviewsData,
  ListMyWrittenReviewsError,
  ListMyWrittenReviewsResponse,
  ListProjectsData,
  ListProjectsError,
  ListProjectsResponse,
  ListPublishedAssignmentScoresData,
  ListPublishedAssignmentScoresError,
  ListPublishedAssignmentScoresResponse,
  ListReviewsData,
  ListReviewsError,
  ListReviewsResponse,
  ListRubricItemOptionsData,
  ListRubricItemOptionsError,
  ListRubricItemOptionsResponse,
  ListRubricItemsData,
  ListRubricItemsError,
  ListRubricItemsResponse,
  ListRubricsData,
  ListRubricsError,
  ListRubricsResponse,
  ListRubricsV2Data,
  ListRubricsV2Error,
  ListRubricsV2Response,
  ListSectionAssignmentsData,
  ListSectionAssignmentsError,
  ListSectionAssignmentsResponse,
  ListSectionEnrollmentsData,
  ListSectionEnrollmentsError,
  ListSectionEnrollmentsResponse,
  ListSectionProjectsData,
  ListSectionProjectsError,
  ListSectionProjectsResponse,
  ListSectionsData,
  ListSectionsError,
  ListSectionsResponse,
  ListTeamAllocationsData,
  ListTeamAllocationsError,
  ListTeamAllocationsResponse,
  ListTeamGroupsData,
  ListTeamGroupsError,
  ListTeamGroupsResponse,
  ListTeamsData,
  ListTeamsError,
  ListTeamsResponse,
  ListUserRubricTemplatesData,
  ListUserRubricTemplatesError,
  ListUserRubricTemplatesResponse,
  LoginData,
  LoginError,
  LoginResponse,
  LogoutData,
  LogoutResponse,
  LtiDeepLinkPayloadData,
  LtiDeepLinkPayloadError,
  LtiDeepLinkPayloadResponse,
  LtiDynamicRegistrationData,
  LtiDynamicRegistrationError,
  LtiDynamicRegistrationResponse,
  LtiGradeSyncData,
  LtiGradeSyncError,
  LtiGradeSyncResponse,
  LtiLaunchData,
  LtiLaunchError,
  LtiLoginGetData,
  LtiLoginGetError,
  LtiLoginPostData,
  LtiLoginPostError,
  LtiRosterSyncData,
  LtiRosterSyncError,
  LtiRosterSyncResponse,
  OpenAssignmentData,
  OpenAssignmentError,
  OpenAssignmentResponse,
  PreviewAssignmentScoresData,
  PreviewAssignmentScoresError,
  PreviewAssignmentScoresResponse,
  PublishAssignmentData,
  PublishAssignmentError,
  PublishAssignmentResponse,
  ReadRootData,
  RecommendExtraTargetsData,
  RecommendExtraTargetsError,
  RecommendExtraTargetsForReviewerTeamData,
  RecommendExtraTargetsForReviewerTeamError,
  RecommendExtraTargetsForReviewerTeamResponse,
  RecommendExtraTargetsResponse,
  ReleaseTeamReviewLockData,
  ReleaseTeamReviewLockError,
  ReleaseTeamReviewLockResponse,
  RemoveLtiDeploymentData,
  RemoveLtiDeploymentError,
  RemoveLtiDeploymentResponse,
  RemoveTeamMemberData,
  RemoveTeamMemberError,
  RemoveTeamMemberResponse,
  RenameSectionData,
  RenameSectionError,
  RenameSectionResponse,
  ReorderRubricItemOptionsData,
  ReorderRubricItemOptionsError,
  ReorderRubricItemOptionsResponse,
  ReorderRubricItemsData,
  ReorderRubricItemsError,
  ReorderRubricItemsResponse,
  ReplaceRubricData,
  ReplaceRubricError,
  ReplaceRubricResponse,
  ResetPasswordData,
  ResetPasswordError,
  ResetPasswordResponse,
  RotateJoinCodeData,
  RotateJoinCodeError,
  RotateJoinCodeResponse,
  RotateSectionJoinCodeData,
  RotateSectionJoinCodeError,
  RotateSectionJoinCodeResponse,
  SaveReviewDraftData,
  SaveReviewDraftError,
  SaveReviewDraftResponse,
  SaveTeamReviewDraftData,
  SaveTeamReviewDraftError,
  SaveTeamReviewDraftResponse,
  SignupData,
  SignupError,
  SignupResponse,
  SubmitReviewData,
  SubmitReviewError,
  SubmitReviewResponse,
  SubmitStaffReviewData,
  SubmitStaffReviewError,
  SubmitStaffReviewResponse,
  SubmitTeamReviewData,
  SubmitTeamReviewError,
  SubmitTeamReviewResponse,
  UnenrollUserData,
  UnenrollUserError,
  UnenrollUserResponse,
  UnsubmitTeamReviewData,
  UnsubmitTeamReviewError,
  UnsubmitTeamReviewResponse,
  UpdateAssignmentData,
  UpdateAssignmentError,
  UpdateAssignmentResponse,
  UpdateAssignmentScoringConfigData,
  UpdateAssignmentScoringConfigError,
  UpdateAssignmentScoringConfigResponse,
  UpdateCourseData,
  UpdateCourseError,
  UpdateCourseResponse,
  UpdateEnrollmentData,
  UpdateEnrollmentError,
  UpdateEnrollmentResponse,
  UpdateLtiClientConfigData,
  UpdateLtiClientConfigError,
  UpdateLtiClientConfigResponse,
  UpdateLtiIssuerData,
  UpdateLtiIssuerError,
  UpdateLtiIssuerResponse,
  UpdateLtiToolKeyData,
  UpdateLtiToolKeyError,
  UpdateLtiToolKeyResponse,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectResponse,
  UpdateRubricData,
  UpdateRubricError,
  UpdateRubricItemData,
  UpdateRubricItemError,
  UpdateRubricItemOptionData,
  UpdateRubricItemOptionError,
  UpdateRubricItemOptionResponse,
  UpdateRubricItemResponse,
  UpdateRubricResponse,
  UpdateTeamData,
  UpdateTeamError,
  UpdateTeamGroupData,
  UpdateTeamGroupError,
  UpdateTeamGroupResponse,
  UpdateTeamResponse,
  UpdateUserData,
  UpdateUserError,
  UpdateUserResponse,
} from "../types.gen"

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const readRootQueryKey = (options?: Options<ReadRootData>) => createQueryKey("readRoot", options)

/**
 * Read Root
 *
 * Temporary root route to redirect to the docs.
 */
export const readRootOptions = (options?: Options<ReadRootData>) =>
  queryOptions<unknown, DefaultError, unknown, ReturnType<typeof readRootQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await readRoot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: readRootQueryKey(options),
  })

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey("healthCheck", options)

/**
 * Health
 *
 * Return a simple service health indicator.
 */
export const healthCheckOptions = (options?: Options<HealthCheckData>) =>
  queryOptions<HealthCheckResponse, DefaultError, HealthCheckResponse, ReturnType<typeof healthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthCheck({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: healthCheckQueryKey(options),
  })

/**
 * Create User
 *
 * Create a new user and return the persisted record. Requires admin role.
 */
export const createUserMutation = (
  options?: Partial<Options<CreateUserData>>,
): UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> => {
  const mutationOptions: UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getCurrentUserQueryKey = (options?: Options<GetCurrentUserData>) =>
  createQueryKey("getCurrentUser", options)

/**
 * Get Current User Info
 *
 * Retrieve the current authenticated user's information.
 */
export const getCurrentUserOptions = (options?: Options<GetCurrentUserData>) =>
  queryOptions<
    GetCurrentUserResponse,
    GetCurrentUserError,
    GetCurrentUserResponse,
    ReturnType<typeof getCurrentUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCurrentUserQueryKey(options),
  })

/**
 * Delete User
 *
 * Delete a user by identifier.
 */
export const deleteUserMutation = (
  options?: Partial<Options<DeleteUserData>>,
): UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> => {
  const mutationOptions: UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getUserQueryKey = (options: Options<GetUserData>) => createQueryKey("getUser", options)

/**
 * Get User
 *
 * Retrieve a user by identifier.
 */
export const getUserOptions = (options: Options<GetUserData>) =>
  queryOptions<GetUserResponse, GetUserError, GetUserResponse, ReturnType<typeof getUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getUserQueryKey(options),
  })

/**
 * Update User
 *
 * Apply partial updates to an existing user. Must be authenticated.
 */
export const updateUserMutation = (
  options?: Partial<Options<UpdateUserData>>,
): UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> => {
  const mutationOptions: UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const ltiLoginGetQueryKey = (options?: Options<LtiLoginGetData>) => createQueryKey("ltiLoginGet", options)

/**
 * Login
 *
 * Start OIDC login. LMS calls this with target_link_uri=<your launch URL>.
 */
export const ltiLoginGetOptions = (options?: Options<LtiLoginGetData>) =>
  queryOptions<unknown, LtiLoginGetError, unknown, ReturnType<typeof ltiLoginGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ltiLoginGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: ltiLoginGetQueryKey(options),
  })

/**
 * Login
 *
 * Start OIDC login. LMS calls this with target_link_uri=<your launch URL>.
 */
export const ltiLoginPostMutation = (
  options?: Partial<Options<LtiLoginPostData>>,
): UseMutationOptions<unknown, LtiLoginPostError, Options<LtiLoginPostData>> => {
  const mutationOptions: UseMutationOptions<unknown, LtiLoginPostError, Options<LtiLoginPostData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await ltiLoginPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Launch
 *
 * LTI message launch. Validates the id_token and issues a backend session before redirecting.
 */
export const ltiLaunchMutation = (
  options?: Partial<Options<LtiLaunchData>>,
): UseMutationOptions<unknown, LtiLaunchError, Options<LtiLaunchData>> => {
  const mutationOptions: UseMutationOptions<unknown, LtiLaunchError, Options<LtiLaunchData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await ltiLaunch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Deep Link Payload
 *
 * Build a Deep Linking response and return an auto-submitting LMS return form.
 *
 * The successful response is HTML, not JSON. The frontend must render it as the current browser document so the
 * generated form POST is submitted by the user agent, preserving the browser-mediated LTI return flow.
 */
export const ltiDeepLinkPayloadMutation = (
  options?: Partial<Options<LtiDeepLinkPayloadData>>,
): UseMutationOptions<LtiDeepLinkPayloadResponse, LtiDeepLinkPayloadError, Options<LtiDeepLinkPayloadData>> => {
  const mutationOptions: UseMutationOptions<
    LtiDeepLinkPayloadResponse,
    LtiDeepLinkPayloadError,
    Options<LtiDeepLinkPayloadData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ltiDeepLinkPayload({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getLtiLaunchContextQueryKey = (options: Options<GetLtiLaunchContextData>) =>
  createQueryKey("getLtiLaunchContext", options)

/**
 * Get Launch Context
 *
 * Retrieve frontend-safe bootstrap context from a short-lived server-side launch context store.
 */
export const getLtiLaunchContextOptions = (options: Options<GetLtiLaunchContextData>) =>
  queryOptions<
    GetLtiLaunchContextResponse,
    GetLtiLaunchContextError,
    GetLtiLaunchContextResponse,
    ReturnType<typeof getLtiLaunchContextQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLtiLaunchContext({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLtiLaunchContextQueryKey(options),
  })

export const getJwksQueryKey = (options?: Options<GetJwksData>) => createQueryKey("getJwks", options)

/**
 * Jwks
 *
 * Expose the tool's JWKS (public keys) from persisted configuration.
 */
export const getJwksOptions = (options?: Options<GetJwksData>) =>
  queryOptions<GetJwksResponse, DefaultError, GetJwksResponse, ReturnType<typeof getJwksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJwks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getJwksQueryKey(options),
  })

/**
 * Dynamic Registration
 *
 * Register this tool dynamically against an LTI Advantage platform.
 */
export const ltiDynamicRegistrationMutation = (
  options?: Partial<Options<LtiDynamicRegistrationData>>,
): UseMutationOptions<
  LtiDynamicRegistrationResponse,
  LtiDynamicRegistrationError,
  Options<LtiDynamicRegistrationData>
> => {
  const mutationOptions: UseMutationOptions<
    LtiDynamicRegistrationResponse,
    LtiDynamicRegistrationError,
    Options<LtiDynamicRegistrationData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await ltiDynamicRegistration({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Roster Sync
 *
 * Sync the LMS roster into a section using a persisted NRPS context link.
 */
export const ltiRosterSyncMutation = (
  options?: Partial<Options<LtiRosterSyncData>>,
): UseMutationOptions<LtiRosterSyncResponse, LtiRosterSyncError, Options<LtiRosterSyncData>> => {
  const mutationOptions: UseMutationOptions<LtiRosterSyncResponse, LtiRosterSyncError, Options<LtiRosterSyncData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await ltiRosterSync({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Grade Sync
 *
 * Sync assignment published scores to LMS line items using a persisted AGS context link.
 */
export const ltiGradeSyncMutation = (
  options?: Partial<Options<LtiGradeSyncData>>,
): UseMutationOptions<LtiGradeSyncResponse, LtiGradeSyncError, Options<LtiGradeSyncData>> => {
  const mutationOptions: UseMutationOptions<LtiGradeSyncResponse, LtiGradeSyncError, Options<LtiGradeSyncData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await ltiGradeSync({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Signup
 *
 * Registers a new user with Supabase.
 *
 * Sends a confirmation email via Supabase to the provided email address.
 */
export const signupMutation = (
  options?: Partial<Options<SignupData>>,
): UseMutationOptions<SignupResponse, SignupError, Options<SignupData>> => {
  const mutationOptions: UseMutationOptions<SignupResponse, SignupError, Options<SignupData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await signup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const confirmSignupQueryKey = (options: Options<ConfirmSignupData>) => createQueryKey("confirmSignup", options)

/**
 * Confirm Signup
 *
 * Confirms the signup originating from Supabase email and redirects to the frontend.
 *
 * This is a GET endpoint because it is intended to be called from a link in an email.
 * The confirmation token is one-time use and expires after verification.
 */
export const confirmSignupOptions = (options: Options<ConfirmSignupData>) =>
  queryOptions<unknown, ConfirmSignupError, unknown, ReturnType<typeof confirmSignupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await confirmSignup({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: confirmSignupQueryKey(options),
  })

/**
 * Login
 *
 * Authenticate a user with Supabase and issue a session cookie.
 */
export const loginMutation = (
  options?: Partial<Options<LoginData>>,
): UseMutationOptions<LoginResponse, LoginError, Options<LoginData>> => {
  const mutationOptions: UseMutationOptions<LoginResponse, LoginError, Options<LoginData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await login({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reset Password
 *
 * Send password reset instructions via Supabase for the provided email.
 */
export const resetPasswordMutation = (
  options?: Partial<Options<ResetPasswordData>>,
): UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> => {
  const mutationOptions: UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetPassword({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Logout
 *
 * Revoke the caller's session cookie if present.
 */
export const logoutMutation = (
  options?: Partial<Options<LogoutData>>,
): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
  const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await logout({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Api Key
 *
 * Delete the current user's API key.
 */
export const deleteApiKeyMutation = (
  options?: Partial<Options<DeleteApiKeyData>>,
): UseMutationOptions<DeleteApiKeyResponse, DeleteApiKeyError, Options<DeleteApiKeyData>> => {
  const mutationOptions: UseMutationOptions<DeleteApiKeyResponse, DeleteApiKeyError, Options<DeleteApiKeyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteApiKey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Create Api Key
 *
 * Create an API key for the current user.
 */
export const createApiKeyMutation = (
  options?: Partial<Options<CreateApiKeyData>>,
): UseMutationOptions<CreateApiKeyResponse, CreateApiKeyError, Options<CreateApiKeyData>> => {
  const mutationOptions: UseMutationOptions<CreateApiKeyResponse, CreateApiKeyError, Options<CreateApiKeyData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createApiKey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listCoursesQueryKey = (options?: Options<ListCoursesData>) => createQueryKey("listCourses", options)

/**
 * List Courses
 *
 * List courses visible to the current user.
 */
export const listCoursesOptions = (options?: Options<ListCoursesData>) =>
  queryOptions<ListCoursesResponse, ListCoursesError, ListCoursesResponse, ReturnType<typeof listCoursesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCourses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listCoursesQueryKey(options),
  })

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] }
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    }
  }
  return params as unknown as typeof page
}

export const listCoursesInfiniteQueryKey = (options?: Options<ListCoursesData>): QueryKey<Options<ListCoursesData>> =>
  createQueryKey("listCourses", options, true)

/**
 * List Courses
 *
 * List courses visible to the current user.
 */
export const listCoursesInfiniteOptions = (options?: Options<ListCoursesData>) =>
  infiniteQueryOptions<
    ListCoursesResponse,
    ListCoursesError,
    InfiniteData<ListCoursesResponse>,
    QueryKey<Options<ListCoursesData>>,
    number | Pick<QueryKey<Options<ListCoursesData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCoursesData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listCourses({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listCoursesInfiniteQueryKey(options),
    },
  )

/**
 * Create Course
 *
 * Create a new course.
 *
 * If owner_id is provided, it must match the current user's ID or the user must be an admin.
 * If owner_id is not provided, the course will be owned by the current user.
 */
export const createCourseMutation = (
  options?: Partial<Options<CreateCourseData>>,
): UseMutationOptions<CreateCourseResponse, CreateCourseError, Options<CreateCourseData>> => {
  const mutationOptions: UseMutationOptions<CreateCourseResponse, CreateCourseError, Options<CreateCourseData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Course
 *
 * Delete a course permanently.
 */
export const deleteCourseMutation = (
  options?: Partial<Options<DeleteCourseData>>,
): UseMutationOptions<DeleteCourseResponse, DeleteCourseError, Options<DeleteCourseData>> => {
  const mutationOptions: UseMutationOptions<DeleteCourseResponse, DeleteCourseError, Options<DeleteCourseData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getCourseQueryKey = (options: Options<GetCourseData>) => createQueryKey("getCourse", options)

/**
 * Get Course
 *
 * Retrieve detailed information for a course.
 */
export const getCourseOptions = (options: Options<GetCourseData>) =>
  queryOptions<GetCourseResponse, GetCourseError, GetCourseResponse, ReturnType<typeof getCourseQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCourse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCourseQueryKey(options),
  })

/**
 * Update Course
 *
 * Apply partial updates to a course.
 *
 * Only admins or the current course owner can update the owner_id field.
 */
export const updateCourseMutation = (
  options?: Partial<Options<UpdateCourseData>>,
): UseMutationOptions<UpdateCourseResponse, UpdateCourseError, Options<UpdateCourseData>> => {
  const mutationOptions: UseMutationOptions<UpdateCourseResponse, UpdateCourseError, Options<UpdateCourseData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Clear Join Code
 *
 * Remove the join code from a course.
 */
export const clearJoinCodeMutation = (
  options?: Partial<Options<ClearJoinCodeData>>,
): UseMutationOptions<ClearJoinCodeResponse, ClearJoinCodeError, Options<ClearJoinCodeData>> => {
  const mutationOptions: UseMutationOptions<ClearJoinCodeResponse, ClearJoinCodeError, Options<ClearJoinCodeData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getJoinCodeQueryKey = (options: Options<GetJoinCodeData>) => createQueryKey("getJoinCode", options)

/**
 * Get Join Code
 *
 * Retrieve the active join code for a course.
 */
export const getJoinCodeOptions = (options: Options<GetJoinCodeData>) =>
  queryOptions<GetJoinCodeResponse, GetJoinCodeError, GetJoinCodeResponse, ReturnType<typeof getJoinCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJoinCode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getJoinCodeQueryKey(options),
  })

/**
 * Adjust Join Code
 *
 * Adjust join code expiration for a course.
 */
export const adjustJoinCodeMutation = (
  options?: Partial<Options<AdjustJoinCodeData>>,
): UseMutationOptions<AdjustJoinCodeResponse, AdjustJoinCodeError, Options<AdjustJoinCodeData>> => {
  const mutationOptions: UseMutationOptions<
    AdjustJoinCodeResponse,
    AdjustJoinCodeError,
    Options<AdjustJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await adjustJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Generate Join Code
 *
 * Deprecated: rotate the join code (works even when none exists).
 *
 * @deprecated
 */
export const generateJoinCodeMutation = (
  options?: Partial<Options<GenerateJoinCodeData>>,
): UseMutationOptions<GenerateJoinCodeResponse, GenerateJoinCodeError, Options<GenerateJoinCodeData>> => {
  const mutationOptions: UseMutationOptions<
    GenerateJoinCodeResponse,
    GenerateJoinCodeError,
    Options<GenerateJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Rotate Join Code
 *
 * Rotate the join code with a newly generated value (or create it if missing).
 */
export const rotateJoinCodeMutation = (
  options?: Partial<Options<RotateJoinCodeData>>,
): UseMutationOptions<RotateJoinCodeResponse, RotateJoinCodeError, Options<RotateJoinCodeData>> => {
  const mutationOptions: UseMutationOptions<
    RotateJoinCodeResponse,
    RotateJoinCodeError,
    Options<RotateJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await rotateJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Clear Section Join Code
 *
 * Remove the join code from a section.
 */
export const clearSectionJoinCodeMutation = (
  options?: Partial<Options<ClearSectionJoinCodeData>>,
): UseMutationOptions<ClearSectionJoinCodeResponse, ClearSectionJoinCodeError, Options<ClearSectionJoinCodeData>> => {
  const mutationOptions: UseMutationOptions<
    ClearSectionJoinCodeResponse,
    ClearSectionJoinCodeError,
    Options<ClearSectionJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await clearSectionJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSectionJoinCodeQueryKey = (options: Options<GetSectionJoinCodeData>) =>
  createQueryKey("getSectionJoinCode", options)

/**
 * Get Section Join Code
 *
 * Retrieve the active join code for a section.
 */
export const getSectionJoinCodeOptions = (options: Options<GetSectionJoinCodeData>) =>
  queryOptions<
    GetSectionJoinCodeResponse,
    GetSectionJoinCodeError,
    GetSectionJoinCodeResponse,
    ReturnType<typeof getSectionJoinCodeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSectionJoinCode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSectionJoinCodeQueryKey(options),
  })

/**
 * Adjust Section Join Code
 *
 * Adjust join code expiration for a section.
 */
export const adjustSectionJoinCodeMutation = (
  options?: Partial<Options<AdjustSectionJoinCodeData>>,
): UseMutationOptions<
  AdjustSectionJoinCodeResponse,
  AdjustSectionJoinCodeError,
  Options<AdjustSectionJoinCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    AdjustSectionJoinCodeResponse,
    AdjustSectionJoinCodeError,
    Options<AdjustSectionJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await adjustSectionJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Generate Section Join Code
 *
 * Deprecated: rotate the join code (works even when none exists).
 *
 * @deprecated
 */
export const generateSectionJoinCodeMutation = (
  options?: Partial<Options<GenerateSectionJoinCodeData>>,
): UseMutationOptions<
  GenerateSectionJoinCodeResponse,
  GenerateSectionJoinCodeError,
  Options<GenerateSectionJoinCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    GenerateSectionJoinCodeResponse,
    GenerateSectionJoinCodeError,
    Options<GenerateSectionJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generateSectionJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Rotate Section Join Code
 *
 * Rotate the join code for a section with a newly generated value (or create it if missing).
 */
export const rotateSectionJoinCodeMutation = (
  options?: Partial<Options<RotateSectionJoinCodeData>>,
): UseMutationOptions<
  RotateSectionJoinCodeResponse,
  RotateSectionJoinCodeError,
  Options<RotateSectionJoinCodeData>
> => {
  const mutationOptions: UseMutationOptions<
    RotateSectionJoinCodeResponse,
    RotateSectionJoinCodeError,
    Options<RotateSectionJoinCodeData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await rotateSectionJoinCode({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Join Course
 *
 * Self-enroll the current user into a course using a join code.
 */
export const joinCourseMutation = (
  options?: Partial<Options<JoinCourseData>>,
): UseMutationOptions<JoinCourseResponse, JoinCourseError, Options<JoinCourseData>> => {
  const mutationOptions: UseMutationOptions<JoinCourseResponse, JoinCourseError, Options<JoinCourseData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await joinCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listSectionsQueryKey = (options: Options<ListSectionsData>) => createQueryKey("listSections", options)

/**
 * Get Sections
 *
 * List sections for a course.
 */
export const listSectionsOptions = (options: Options<ListSectionsData>) =>
  queryOptions<ListSectionsResponse, ListSectionsError, ListSectionsResponse, ReturnType<typeof listSectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSectionsQueryKey(options),
  })

/**
 * Create Section
 *
 * Create a new section within a course.
 */
export const createSectionMutation = (
  options?: Partial<Options<CreateSectionData>>,
): UseMutationOptions<CreateSectionResponse, CreateSectionError, Options<CreateSectionData>> => {
  const mutationOptions: UseMutationOptions<CreateSectionResponse, CreateSectionError, Options<CreateSectionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createSection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Archive Section
 *
 * Archive a course section.
 */
export const archiveSectionMutation = (
  options?: Partial<Options<ArchiveSectionData>>,
): UseMutationOptions<ArchiveSectionResponse, ArchiveSectionError, Options<ArchiveSectionData>> => {
  const mutationOptions: UseMutationOptions<
    ArchiveSectionResponse,
    ArchiveSectionError,
    Options<ArchiveSectionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await archiveSection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getSectionQueryKey = (options: Options<GetSectionData>) => createQueryKey("getSection", options)

/**
 * Get Section
 *
 * Retrieve a single section within a course.
 */
export const getSectionOptions = (options: Options<GetSectionData>) =>
  queryOptions<GetSectionResponse, GetSectionError, GetSectionResponse, ReturnType<typeof getSectionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSection({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getSectionQueryKey(options),
  })

/**
 * Rename Section
 *
 * Rename an existing course section.
 */
export const renameSectionMutation = (
  options?: Partial<Options<RenameSectionData>>,
): UseMutationOptions<RenameSectionResponse, RenameSectionError, Options<RenameSectionData>> => {
  const mutationOptions: UseMutationOptions<RenameSectionResponse, RenameSectionError, Options<RenameSectionData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await renameSection({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listTeamGroupsQueryKey = (options: Options<ListTeamGroupsData>) =>
  createQueryKey("listTeamGroups", options)

/**
 * List Team Groups
 *
 * List team groups for a course.
 */
export const listTeamGroupsOptions = (options: Options<ListTeamGroupsData>) =>
  queryOptions<
    ListTeamGroupsResponse,
    ListTeamGroupsError,
    ListTeamGroupsResponse,
    ReturnType<typeof listTeamGroupsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTeamGroups({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listTeamGroupsQueryKey(options),
  })

/**
 * Create Team Group
 *
 * Create a new team group within a course.
 */
export const createTeamGroupMutation = (
  options?: Partial<Options<CreateTeamGroupData>>,
): UseMutationOptions<CreateTeamGroupResponse, CreateTeamGroupError, Options<CreateTeamGroupData>> => {
  const mutationOptions: UseMutationOptions<
    CreateTeamGroupResponse,
    CreateTeamGroupError,
    Options<CreateTeamGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTeamGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Team Group
 *
 * Delete a team group from a course.
 */
export const deleteTeamGroupMutation = (
  options?: Partial<Options<DeleteTeamGroupData>>,
): UseMutationOptions<DeleteTeamGroupResponse, DeleteTeamGroupError, Options<DeleteTeamGroupData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteTeamGroupResponse,
    DeleteTeamGroupError,
    Options<DeleteTeamGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTeamGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update Team Group
 *
 * Update a team group within a course.
 */
export const updateTeamGroupMutation = (
  options?: Partial<Options<UpdateTeamGroupData>>,
): UseMutationOptions<UpdateTeamGroupResponse, UpdateTeamGroupError, Options<UpdateTeamGroupData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateTeamGroupResponse,
    UpdateTeamGroupError,
    Options<UpdateTeamGroupData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTeamGroup({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listTeamsQueryKey = (options: Options<ListTeamsData>) => createQueryKey("listTeams", options)

/**
 * List Teams
 *
 * List teams in a course with optional team-group, section, and membership filters.
 */
export const listTeamsOptions = (options: Options<ListTeamsData>) =>
  queryOptions<ListTeamsResponse, ListTeamsError, ListTeamsResponse, ReturnType<typeof listTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTeams({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listTeamsQueryKey(options),
  })

/**
 * Create Team
 *
 * Create a team in a course.
 */
export const createTeamMutation = (
  options?: Partial<Options<CreateTeamData>>,
): UseMutationOptions<CreateTeamResponse, CreateTeamError, Options<CreateTeamData>> => {
  const mutationOptions: UseMutationOptions<CreateTeamResponse, CreateTeamError, Options<CreateTeamData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Team
 *
 * Delete a team from a course.
 */
export const deleteTeamMutation = (
  options?: Partial<Options<DeleteTeamData>>,
): UseMutationOptions<DeleteTeamResponse, DeleteTeamError, Options<DeleteTeamData>> => {
  const mutationOptions: UseMutationOptions<DeleteTeamResponse, DeleteTeamError, Options<DeleteTeamData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update Team
 *
 * Update team attributes within a course.
 */
export const updateTeamMutation = (
  options?: Partial<Options<UpdateTeamData>>,
): UseMutationOptions<UpdateTeamResponse, UpdateTeamError, Options<UpdateTeamData>> => {
  const mutationOptions: UseMutationOptions<UpdateTeamResponse, UpdateTeamError, Options<UpdateTeamData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Add Team Member
 *
 * Add an enrolled user to a team.
 */
export const addTeamMemberMutation = (
  options?: Partial<Options<AddTeamMemberData>>,
): UseMutationOptions<AddTeamMemberResponse, AddTeamMemberError, Options<AddTeamMemberData>> => {
  const mutationOptions: UseMutationOptions<AddTeamMemberResponse, AddTeamMemberError, Options<AddTeamMemberData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addTeamMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Bulk Add Team Members
 *
 * Add multiple enrolled users to a team in one request.
 */
export const bulkAddTeamMembersMutation = (
  options?: Partial<Options<BulkAddTeamMembersData>>,
): UseMutationOptions<BulkAddTeamMembersResponse, BulkAddTeamMembersError, Options<BulkAddTeamMembersData>> => {
  const mutationOptions: UseMutationOptions<
    BulkAddTeamMembersResponse,
    BulkAddTeamMembersError,
    Options<BulkAddTeamMembersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkAddTeamMembers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Remove Team Member
 *
 * Remove an enrolled user from a team.
 */
export const removeTeamMemberMutation = (
  options?: Partial<Options<RemoveTeamMemberData>>,
): UseMutationOptions<RemoveTeamMemberResponse, RemoveTeamMemberError, Options<RemoveTeamMemberData>> => {
  const mutationOptions: UseMutationOptions<
    RemoveTeamMemberResponse,
    RemoveTeamMemberError,
    Options<RemoveTeamMemberData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeTeamMember({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Bulk Remove Team Members
 *
 * Remove multiple enrolled users from a team in one request.
 */
export const bulkRemoveTeamMembersMutation = (
  options?: Partial<Options<BulkRemoveTeamMembersData>>,
): UseMutationOptions<
  BulkRemoveTeamMembersResponse,
  BulkRemoveTeamMembersError,
  Options<BulkRemoveTeamMembersData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkRemoveTeamMembersResponse,
    BulkRemoveTeamMembersError,
    Options<BulkRemoveTeamMembersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkRemoveTeamMembers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listSectionAssignmentsQueryKey = (options: Options<ListSectionAssignmentsData>) =>
  createQueryKey("listSectionAssignments", options)

/**
 * List Section Assignments
 *
 * List assignments visible for a section.
 *
 * Returns all assignments for the section's course.
 */
export const listSectionAssignmentsOptions = (options: Options<ListSectionAssignmentsData>) =>
  queryOptions<
    ListSectionAssignmentsResponse,
    ListSectionAssignmentsError,
    ListSectionAssignmentsResponse,
    ReturnType<typeof listSectionAssignmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSectionAssignments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSectionAssignmentsQueryKey(options),
  })

export const listSectionAssignmentsInfiniteQueryKey = (
  options: Options<ListSectionAssignmentsData>,
): QueryKey<Options<ListSectionAssignmentsData>> => createQueryKey("listSectionAssignments", options, true)

/**
 * List Section Assignments
 *
 * List assignments visible for a section.
 *
 * Returns all assignments for the section's course.
 */
export const listSectionAssignmentsInfiniteOptions = (options: Options<ListSectionAssignmentsData>) =>
  infiniteQueryOptions<
    ListSectionAssignmentsResponse,
    ListSectionAssignmentsError,
    InfiniteData<ListSectionAssignmentsResponse>,
    QueryKey<Options<ListSectionAssignmentsData>>,
    number | Pick<QueryKey<Options<ListSectionAssignmentsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSectionAssignmentsData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listSectionAssignments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listSectionAssignmentsInfiniteQueryKey(options),
    },
  )

export const listSectionProjectsQueryKey = (options: Options<ListSectionProjectsData>) =>
  createQueryKey("listSectionProjects", options)

/**
 * List Section Projects
 *
 * List projects for the section's course.
 *
 * Projects belong to courses rather than sections, so this returns all projects
 * for the course that contains this section.
 */
export const listSectionProjectsOptions = (options: Options<ListSectionProjectsData>) =>
  queryOptions<
    ListSectionProjectsResponse,
    ListSectionProjectsError,
    ListSectionProjectsResponse,
    ReturnType<typeof listSectionProjectsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSectionProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSectionProjectsQueryKey(options),
  })

export const listMembersQueryKey = (options: Options<ListMembersData>) => createQueryKey("listMembers", options)

/**
 * List Members
 *
 * List course members with member-tab fields.
 *
 * This endpoint is a roster projection for UI consumption and includes team,
 * permission-filtered email, and review progress values. For canonical
 * enrollment records (without member projection fields), use
 * ``GET /courses/{course_id}/enrollments`` or
 * ``GET /courses/{course_id}/sections/{section_id}/enrollments``.
 */
export const listMembersOptions = (options: Options<ListMembersData>) =>
  queryOptions<ListMembersResponse, ListMembersError, ListMembersResponse, ReturnType<typeof listMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listMembersQueryKey(options),
  })

export const listMembersInfiniteQueryKey = (options: Options<ListMembersData>): QueryKey<Options<ListMembersData>> =>
  createQueryKey("listMembers", options, true)

/**
 * List Members
 *
 * List course members with member-tab fields.
 *
 * This endpoint is a roster projection for UI consumption and includes team,
 * permission-filtered email, and review progress values. For canonical
 * enrollment records (without member projection fields), use
 * ``GET /courses/{course_id}/enrollments`` or
 * ``GET /courses/{course_id}/sections/{section_id}/enrollments``.
 */
export const listMembersInfiniteOptions = (options: Options<ListMembersData>) =>
  infiniteQueryOptions<
    ListMembersResponse,
    ListMembersError,
    InfiniteData<ListMembersResponse>,
    QueryKey<Options<ListMembersData>>,
    number | Pick<QueryKey<Options<ListMembersData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListMembersData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listMembers({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listMembersInfiniteQueryKey(options),
    },
  )

export const listSectionEnrollmentsQueryKey = (options: Options<ListSectionEnrollmentsData>) =>
  createQueryKey("listSectionEnrollments", options)

/**
 * List Section Enrollments
 *
 * List canonical enrollment records for a specific section.
 *
 * This endpoint returns enrollment entities (user summary, role, section_id)
 * rather than member-tab projection fields. For member roster data such as
 * team assignment, permission-filtered email, and progress, use
 * ``GET /courses/{course_id}/members?section_id={section_id}``.
 */
export const listSectionEnrollmentsOptions = (options: Options<ListSectionEnrollmentsData>) =>
  queryOptions<
    ListSectionEnrollmentsResponse,
    ListSectionEnrollmentsError,
    ListSectionEnrollmentsResponse,
    ReturnType<typeof listSectionEnrollmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSectionEnrollments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listSectionEnrollmentsQueryKey(options),
  })

export const listSectionEnrollmentsInfiniteQueryKey = (
  options: Options<ListSectionEnrollmentsData>,
): QueryKey<Options<ListSectionEnrollmentsData>> => createQueryKey("listSectionEnrollments", options, true)

/**
 * List Section Enrollments
 *
 * List canonical enrollment records for a specific section.
 *
 * This endpoint returns enrollment entities (user summary, role, section_id)
 * rather than member-tab projection fields. For member roster data such as
 * team assignment, permission-filtered email, and progress, use
 * ``GET /courses/{course_id}/members?section_id={section_id}``.
 */
export const listSectionEnrollmentsInfiniteOptions = (options: Options<ListSectionEnrollmentsData>) =>
  infiniteQueryOptions<
    ListSectionEnrollmentsResponse,
    ListSectionEnrollmentsError,
    InfiniteData<ListSectionEnrollmentsResponse>,
    QueryKey<Options<ListSectionEnrollmentsData>>,
    number | Pick<QueryKey<Options<ListSectionEnrollmentsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSectionEnrollmentsData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listSectionEnrollments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listSectionEnrollmentsInfiniteQueryKey(options),
    },
  )

export const listEnrollmentsQueryKey = (options: Options<ListEnrollmentsData>) =>
  createQueryKey("listEnrollments", options)

/**
 * Get Enrollments
 *
 * List canonical enrollment records for a course.
 *
 * This endpoint returns enrollment entities (user summary, role, section_id)
 * rather than member-tab projection fields. For member roster data such as
 * team assignment, permission-filtered email, and progress, use
 * ``GET /courses/{course_id}/members``.
 */
export const listEnrollmentsOptions = (options: Options<ListEnrollmentsData>) =>
  queryOptions<
    ListEnrollmentsResponse,
    ListEnrollmentsError,
    ListEnrollmentsResponse,
    ReturnType<typeof listEnrollmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEnrollments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listEnrollmentsQueryKey(options),
  })

export const listEnrollmentsInfiniteQueryKey = (
  options: Options<ListEnrollmentsData>,
): QueryKey<Options<ListEnrollmentsData>> => createQueryKey("listEnrollments", options, true)

/**
 * Get Enrollments
 *
 * List canonical enrollment records for a course.
 *
 * This endpoint returns enrollment entities (user summary, role, section_id)
 * rather than member-tab projection fields. For member roster data such as
 * team assignment, permission-filtered email, and progress, use
 * ``GET /courses/{course_id}/members``.
 */
export const listEnrollmentsInfiniteOptions = (options: Options<ListEnrollmentsData>) =>
  infiniteQueryOptions<
    ListEnrollmentsResponse,
    ListEnrollmentsError,
    InfiniteData<ListEnrollmentsResponse>,
    QueryKey<Options<ListEnrollmentsData>>,
    number | Pick<QueryKey<Options<ListEnrollmentsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListEnrollmentsData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listEnrollments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listEnrollmentsInfiniteQueryKey(options),
    },
  )

/**
 * Enroll User
 *
 * Enroll a user in a course.
 */
export const enrollUserMutation = (
  options?: Partial<Options<EnrollUserData>>,
): UseMutationOptions<EnrollUserResponse, EnrollUserError, Options<EnrollUserData>> => {
  const mutationOptions: UseMutationOptions<EnrollUserResponse, EnrollUserError, Options<EnrollUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await enrollUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Bulk Unenroll Users
 *
 * Remove multiple users from a course and return the number of affected rows.
 */
export const bulkUnenrollUsersMutation = (
  options?: Partial<Options<BulkUnenrollUsersData>>,
): UseMutationOptions<BulkUnenrollUsersResponse, BulkUnenrollUsersError, Options<BulkUnenrollUsersData>> => {
  const mutationOptions: UseMutationOptions<
    BulkUnenrollUsersResponse,
    BulkUnenrollUsersError,
    Options<BulkUnenrollUsersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkUnenrollUsers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Bulk Enroll Users
 *
 * Enroll multiple users in a course and return the number of affected rows.
 */
export const bulkEnrollUsersMutation = (
  options?: Partial<Options<BulkEnrollUsersData>>,
): UseMutationOptions<BulkEnrollUsersResponse, BulkEnrollUsersError, Options<BulkEnrollUsersData>> => {
  const mutationOptions: UseMutationOptions<
    BulkEnrollUsersResponse,
    BulkEnrollUsersError,
    Options<BulkEnrollUsersData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkEnrollUsers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Unenroll User
 *
 * Remove a user from a course.
 */
export const unenrollUserMutation = (
  options?: Partial<Options<UnenrollUserData>>,
): UseMutationOptions<UnenrollUserResponse, UnenrollUserError, Options<UnenrollUserData>> => {
  const mutationOptions: UseMutationOptions<UnenrollUserResponse, UnenrollUserError, Options<UnenrollUserData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await unenrollUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update Enrollment
 *
 * Update enrollment role and/or section assignment.
 */
export const updateEnrollmentMutation = (
  options?: Partial<Options<UpdateEnrollmentData>>,
): UseMutationOptions<UpdateEnrollmentResponse, UpdateEnrollmentError, Options<UpdateEnrollmentData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateEnrollmentResponse,
    UpdateEnrollmentError,
    Options<UpdateEnrollmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateEnrollment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Import Roster
 *
 * Import a course roster from CSV with preview (`dry_run=true`) or apply (`dry_run=false`) semantics.
 *
 * How matching works:
 * - User discriminator: each row is matched to an existing user by normalized `Email address`.
 * - The import does **not** create new users. Rows for unknown emails are skipped with `"User not found for email"`.
 *
 * Source format requirements:
 * - `moodle`:
 * - Required headers: `Email address`, `First name`, `Last name`, `Groups`.
 * - `section_id` is required because Moodle CSV does not contain a section column.
 * - `Groups` is split on the exact delimiter `", "` to derive team names.
 *
 * Import processing flow:
 * 1. Parse/validate CSV headers and row-level required values.
 * 2. De-duplicate rows by normalized email (team names are merged).
 * 3. Resolve users by email and plan per-row actions.
 * 4. Apply mutations only when `dry_run=false`.
 */
export const importRosterMutation = (
  options?: Partial<Options<ImportRosterData>>,
): UseMutationOptions<ImportRosterResponse, ImportRosterError, Options<ImportRosterData>> => {
  const mutationOptions: UseMutationOptions<ImportRosterResponse, ImportRosterError, Options<ImportRosterData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await importRoster({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const exportRosterQueryKey = (options: Options<ExportRosterData>) => createQueryKey("exportRoster", options)

/**
 * Export Roster
 *
 * Export student roster as CSV in the requested source format.
 */
export const exportRosterOptions = (options: Options<ExportRosterData>) =>
  queryOptions<unknown, ExportRosterError, unknown, ReturnType<typeof exportRosterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportRoster({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportRosterQueryKey(options),
  })

export const exportGradebookQueryKey = (options: Options<ExportGradebookData>) =>
  createQueryKey("exportGradebook", options)

/**
 * Export Gradebook
 *
 * Export course-wide gradebook as CSV.
 *
 * One row per student with overall and per-criterion scores for every
 * published assignment. Supports anonymization toggle.
 */
export const exportGradebookOptions = (options: Options<ExportGradebookData>) =>
  queryOptions<unknown, ExportGradebookError, unknown, ReturnType<typeof exportGradebookQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportGradebook({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportGradebookQueryKey(options),
  })

export const listCoursePublishedScoresQueryKey = (options: Options<ListCoursePublishedScoresData>) =>
  createQueryKey("listCoursePublishedScores", options)

/**
 * List Course Published Scores
 *
 * List all published assignment score rows for a course.
 */
export const listCoursePublishedScoresOptions = (options: Options<ListCoursePublishedScoresData>) =>
  queryOptions<
    ListCoursePublishedScoresResponse,
    ListCoursePublishedScoresError,
    ListCoursePublishedScoresResponse,
    ReturnType<typeof listCoursePublishedScoresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listCoursePublishedScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listCoursePublishedScoresQueryKey(options),
  })

export const getMyPublishedScoresForCourseQueryKey = (options: Options<GetMyPublishedScoresForCourseData>) =>
  createQueryKey("getMyPublishedScoresForCourse", options)

/**
 * Get My Published Scores For Course
 *
 * Return assignment/project/course published scores for the current user in a course.
 */
export const getMyPublishedScoresForCourseOptions = (options: Options<GetMyPublishedScoresForCourseData>) =>
  queryOptions<
    GetMyPublishedScoresForCourseResponse,
    GetMyPublishedScoresForCourseError,
    GetMyPublishedScoresForCourseResponse,
    ReturnType<typeof getMyPublishedScoresForCourseQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyPublishedScoresForCourse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMyPublishedScoresForCourseQueryKey(options),
  })

export const getCourseSummaryQueryKey = (options: Options<GetCourseSummaryData>) =>
  createQueryKey("getCourseSummary", options)

/**
 * Get Course Summary
 *
 * Retrieve aggregated metrics for the course dashboard.
 */
export const getCourseSummaryOptions = (options: Options<GetCourseSummaryData>) =>
  queryOptions<
    GetCourseSummaryResponse,
    GetCourseSummaryError,
    GetCourseSummaryResponse,
    ReturnType<typeof getCourseSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCourseSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getCourseSummaryQueryKey(options),
  })

export const getInstructorDashboardQueryKey = (options?: Options<GetInstructorDashboardData>) =>
  createQueryKey("getInstructorDashboard", options)

/**
 * Get Instructor Dashboard
 *
 * Retrieve aggregated dashboard metrics for instructor-facing views.
 */
export const getInstructorDashboardOptions = (options?: Options<GetInstructorDashboardData>) =>
  queryOptions<
    GetInstructorDashboardResponse,
    GetInstructorDashboardError,
    GetInstructorDashboardResponse,
    ReturnType<typeof getInstructorDashboardQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getInstructorDashboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getInstructorDashboardQueryKey(options),
  })

export const getStudentDashboardQueryKey = (options?: Options<GetStudentDashboardData>) =>
  createQueryKey("getStudentDashboard", options)

/**
 * Get Student Dashboard
 *
 * Retrieve aggregated dashboard metrics for student-facing views.
 */
export const getStudentDashboardOptions = (options?: Options<GetStudentDashboardData>) =>
  queryOptions<
    GetStudentDashboardResponse,
    GetStudentDashboardError,
    GetStudentDashboardResponse,
    ReturnType<typeof getStudentDashboardQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getStudentDashboard({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getStudentDashboardQueryKey(options),
  })

export const listProjectsQueryKey = (options: Options<ListProjectsData>) => createQueryKey("listProjects", options)

/**
 * List Projects
 *
 * List projects for a course.
 */
export const listProjectsOptions = (options: Options<ListProjectsData>) =>
  queryOptions<ListProjectsResponse, ListProjectsError, ListProjectsResponse, ReturnType<typeof listProjectsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listProjects({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listProjectsQueryKey(options),
  })

/**
 * Create Project
 *
 * Create a project within a course.
 */
export const createProjectMutation = (
  options?: Partial<Options<CreateProjectData>>,
): UseMutationOptions<CreateProjectResponse, CreateProjectError, Options<CreateProjectData>> => {
  const mutationOptions: UseMutationOptions<CreateProjectResponse, CreateProjectError, Options<CreateProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Project
 *
 * Delete a project from a course.
 */
export const deleteProjectMutation = (
  options?: Partial<Options<DeleteProjectData>>,
): UseMutationOptions<DeleteProjectResponse, DeleteProjectError, Options<DeleteProjectData>> => {
  const mutationOptions: UseMutationOptions<DeleteProjectResponse, DeleteProjectError, Options<DeleteProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectQueryKey = (options: Options<GetProjectData>) => createQueryKey("getProject", options)

/**
 * Get Project
 *
 * Retrieve a single project by its identifier.
 */
export const getProjectOptions = (options: Options<GetProjectData>) =>
  queryOptions<GetProjectResponse, GetProjectError, GetProjectResponse, ReturnType<typeof getProjectQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProject({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectQueryKey(options),
  })

/**
 * Update Project
 *
 * Update metadata for a project.
 */
export const updateProjectMutation = (
  options?: Partial<Options<UpdateProjectData>>,
): UseMutationOptions<UpdateProjectResponse, UpdateProjectError, Options<UpdateProjectData>> => {
  const mutationOptions: UseMutationOptions<UpdateProjectResponse, UpdateProjectError, Options<UpdateProjectData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateProject({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getProjectReviewSummaryQueryKey = (options: Options<GetProjectReviewSummaryData>) =>
  createQueryKey("getProjectReviewSummary", options)

/**
 * Get Project Review Summary
 *
 * Retrieve actor-scoped review summary metrics for a project.
 */
export const getProjectReviewSummaryOptions = (options: Options<GetProjectReviewSummaryData>) =>
  queryOptions<
    GetProjectReviewSummaryResponse,
    GetProjectReviewSummaryError,
    GetProjectReviewSummaryResponse,
    ReturnType<typeof getProjectReviewSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProjectReviewSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getProjectReviewSummaryQueryKey(options),
  })

export const listUserRubricTemplatesQueryKey = (options: Options<ListUserRubricTemplatesData>) =>
  createQueryKey("listUserRubricTemplates", options)

/**
 * List User Rubric Templates
 *
 * List reusable rubric templates created by a specific user.
 *
 * Deprecated: Use `GET /rubrics?created_by=<user_id>&is_template=true` instead, which supports the same functionality
 * with a more flexible filter-based approach and without requiring a user-scoped endpoint.
 *
 * @deprecated
 */
export const listUserRubricTemplatesOptions = (options: Options<ListUserRubricTemplatesData>) =>
  queryOptions<
    ListUserRubricTemplatesResponse,
    ListUserRubricTemplatesError,
    ListUserRubricTemplatesResponse,
    ReturnType<typeof listUserRubricTemplatesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUserRubricTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listUserRubricTemplatesQueryKey(options),
  })

export const listUserRubricTemplatesInfiniteQueryKey = (
  options: Options<ListUserRubricTemplatesData>,
): QueryKey<Options<ListUserRubricTemplatesData>> => createQueryKey("listUserRubricTemplates", options, true)

/**
 * List User Rubric Templates
 *
 * List reusable rubric templates created by a specific user.
 *
 * Deprecated: Use `GET /rubrics?created_by=<user_id>&is_template=true` instead, which supports the same functionality
 * with a more flexible filter-based approach and without requiring a user-scoped endpoint.
 *
 * @deprecated
 */
export const listUserRubricTemplatesInfiniteOptions = (options: Options<ListUserRubricTemplatesData>) =>
  infiniteQueryOptions<
    ListUserRubricTemplatesResponse,
    ListUserRubricTemplatesError,
    InfiniteData<ListUserRubricTemplatesResponse>,
    QueryKey<Options<ListUserRubricTemplatesData>>,
    number | Pick<QueryKey<Options<ListUserRubricTemplatesData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListUserRubricTemplatesData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listUserRubricTemplates({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listUserRubricTemplatesInfiniteQueryKey(options),
    },
  )

export const listRubricsV2QueryKey = (options?: Options<ListRubricsV2Data>) => createQueryKey("listRubricsV2", options)

/**
 * List Rubric Collection
 *
 * List rubrics by course or creator using a single collection endpoint.
 */
export const listRubricsV2Options = (options?: Options<ListRubricsV2Data>) =>
  queryOptions<
    ListRubricsV2Response,
    ListRubricsV2Error,
    ListRubricsV2Response,
    ReturnType<typeof listRubricsV2QueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRubricsV2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRubricsV2QueryKey(options),
  })

export const listRubricsV2InfiniteQueryKey = (
  options?: Options<ListRubricsV2Data>,
): QueryKey<Options<ListRubricsV2Data>> => createQueryKey("listRubricsV2", options, true)

/**
 * List Rubric Collection
 *
 * List rubrics by course or creator using a single collection endpoint.
 */
export const listRubricsV2InfiniteOptions = (options?: Options<ListRubricsV2Data>) =>
  infiniteQueryOptions<
    ListRubricsV2Response,
    ListRubricsV2Error,
    InfiniteData<ListRubricsV2Response>,
    QueryKey<Options<ListRubricsV2Data>>,
    number | Pick<QueryKey<Options<ListRubricsV2Data>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListRubricsV2Data>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listRubricsV2({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listRubricsV2InfiniteQueryKey(options),
    },
  )

/**
 * Create Rubric
 *
 * Create a rubric, optionally binding it to a course.
 */
export const createRubricV2Mutation = (
  options?: Partial<Options<CreateRubricV2Data>>,
): UseMutationOptions<CreateRubricV2Response, CreateRubricV2Error, Options<CreateRubricV2Data>> => {
  const mutationOptions: UseMutationOptions<
    CreateRubricV2Response,
    CreateRubricV2Error,
    Options<CreateRubricV2Data>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createRubricV2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listRubricsQueryKey = (options: Options<ListRubricsData>) => createQueryKey("listRubrics", options)

/**
 * List Rubrics For Course
 *
 * List rubrics for a course via a deprecated endpoint; use `GET /rubrics?course_id=<id>` instead.
 *
 * @deprecated
 */
export const listRubricsOptions = (options: Options<ListRubricsData>) =>
  queryOptions<ListRubricsResponse, ListRubricsError, ListRubricsResponse, ReturnType<typeof listRubricsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRubrics({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRubricsQueryKey(options),
  })

export const listRubricsInfiniteQueryKey = (options: Options<ListRubricsData>): QueryKey<Options<ListRubricsData>> =>
  createQueryKey("listRubrics", options, true)

/**
 * List Rubrics For Course
 *
 * List rubrics for a course via a deprecated endpoint; use `GET /rubrics?course_id=<id>` instead.
 *
 * @deprecated
 */
export const listRubricsInfiniteOptions = (options: Options<ListRubricsData>) =>
  infiniteQueryOptions<
    ListRubricsResponse,
    ListRubricsError,
    InfiniteData<ListRubricsResponse>,
    QueryKey<Options<ListRubricsData>>,
    number | Pick<QueryKey<Options<ListRubricsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListRubricsData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listRubrics({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listRubricsInfiniteQueryKey(options),
    },
  )

/**
 * Create Rubric For Course
 *
 * Create a course rubric via a deprecated endpoint; use `POST /rubrics` with `course_id` instead.
 *
 * @deprecated
 */
export const createRubricMutation = (
  options?: Partial<Options<CreateRubricData>>,
): UseMutationOptions<CreateRubricResponse, CreateRubricError, Options<CreateRubricData>> => {
  const mutationOptions: UseMutationOptions<CreateRubricResponse, CreateRubricError, Options<CreateRubricData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await createRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Rubric
 *
 * Delete a rubric permanently.
 */
export const deleteRubricMutation = (
  options?: Partial<Options<DeleteRubricData>>,
): UseMutationOptions<DeleteRubricResponse, DeleteRubricError, Options<DeleteRubricData>> => {
  const mutationOptions: UseMutationOptions<DeleteRubricResponse, DeleteRubricError, Options<DeleteRubricData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getRubricQueryKey = (options: Options<GetRubricData>) => createQueryKey("getRubric", options)

/**
 * Get Rubric
 *
 * Retrieve detailed information for a rubric.
 */
export const getRubricOptions = (options: Options<GetRubricData>) =>
  queryOptions<GetRubricResponse, GetRubricError, GetRubricResponse, ReturnType<typeof getRubricQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRubric({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRubricQueryKey(options),
  })

/**
 * Update Rubric
 *
 * Apply partial updates to a rubric.
 */
export const updateRubricMutation = (
  options?: Partial<Options<UpdateRubricData>>,
): UseMutationOptions<UpdateRubricResponse, UpdateRubricError, Options<UpdateRubricData>> => {
  const mutationOptions: UseMutationOptions<UpdateRubricResponse, UpdateRubricError, Options<UpdateRubricData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Replace Rubric
 *
 * Replace entire rubric structure atomically.
 *
 * This endpoint performs a full replacement of rubric metadata and nested structure in
 * one transaction. The request body is treated as the new source of truth for the rubric:
 * - Items/options with IDs that exist are updated in place
 * - Items/options with IDs that don't exist raise an error
 * - Items/options without IDs are created
 * - Items/options not in the request are deleted
 *
 * Use this endpoint when a client edits the complete rubric in memory and wants to persist
 * it as a single operation (for example, after drag-and-drop reordering and bulk edits).
 * Include all desired items/options with explicit `sort_order` values to control final order.
 * If any nested validation or lookup fails (invalid config, unknown item/option IDs, duplicate
 * slugs), no partial changes are committed.
 */
export const replaceRubricMutation = (
  options?: Partial<Options<ReplaceRubricData>>,
): UseMutationOptions<ReplaceRubricResponse, ReplaceRubricError, Options<ReplaceRubricData>> => {
  const mutationOptions: UseMutationOptions<ReplaceRubricResponse, ReplaceRubricError, Options<ReplaceRubricData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceRubric({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listRubricItemsQueryKey = (options: Options<ListRubricItemsData>) =>
  createQueryKey("listRubricItems", options)

/**
 * List Rubric Items
 *
 * List items for a rubric.
 */
export const listRubricItemsOptions = (options: Options<ListRubricItemsData>) =>
  queryOptions<
    ListRubricItemsResponse,
    ListRubricItemsError,
    ListRubricItemsResponse,
    ReturnType<typeof listRubricItemsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRubricItems({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRubricItemsQueryKey(options),
  })

/**
 * Create Rubric Item
 *
 * Add a new item to a rubric.
 */
export const createRubricItemMutation = (
  options?: Partial<Options<CreateRubricItemData>>,
): UseMutationOptions<CreateRubricItemResponse, CreateRubricItemError, Options<CreateRubricItemData>> => {
  const mutationOptions: UseMutationOptions<
    CreateRubricItemResponse,
    CreateRubricItemError,
    Options<CreateRubricItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createRubricItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Rubric Item
 *
 * Remove an item from a rubric.
 */
export const deleteRubricItemMutation = (
  options?: Partial<Options<DeleteRubricItemData>>,
): UseMutationOptions<DeleteRubricItemResponse, DeleteRubricItemError, Options<DeleteRubricItemData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteRubricItemResponse,
    DeleteRubricItemError,
    Options<DeleteRubricItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteRubricItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update Rubric Item
 *
 * Update a rubric item.
 */
export const updateRubricItemMutation = (
  options?: Partial<Options<UpdateRubricItemData>>,
): UseMutationOptions<UpdateRubricItemResponse, UpdateRubricItemError, Options<UpdateRubricItemData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateRubricItemResponse,
    UpdateRubricItemError,
    Options<UpdateRubricItemData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateRubricItem({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reorder Rubric Items
 *
 * Reorder rubric items.
 */
export const reorderRubricItemsMutation = (
  options?: Partial<Options<ReorderRubricItemsData>>,
): UseMutationOptions<ReorderRubricItemsResponse, ReorderRubricItemsError, Options<ReorderRubricItemsData>> => {
  const mutationOptions: UseMutationOptions<
    ReorderRubricItemsResponse,
    ReorderRubricItemsError,
    Options<ReorderRubricItemsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderRubricItems({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listRubricItemOptionsQueryKey = (options: Options<ListRubricItemOptionsData>) =>
  createQueryKey("listRubricItemOptions", options)

/**
 * List Rubric Item Options
 *
 * List options for a rubric item.
 */
export const listRubricItemOptionsOptions = (options: Options<ListRubricItemOptionsData>) =>
  queryOptions<
    ListRubricItemOptionsResponse,
    ListRubricItemOptionsError,
    ListRubricItemOptionsResponse,
    ReturnType<typeof listRubricItemOptionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRubricItemOptions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listRubricItemOptionsQueryKey(options),
  })

/**
 * Create Rubric Item Option
 *
 * Add an option to a rubric item.
 */
export const createRubricItemOptionMutation = (
  options?: Partial<Options<CreateRubricItemOptionData>>,
): UseMutationOptions<
  CreateRubricItemOptionResponse,
  CreateRubricItemOptionError,
  Options<CreateRubricItemOptionData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateRubricItemOptionResponse,
    CreateRubricItemOptionError,
    Options<CreateRubricItemOptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createRubricItemOption({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Rubric Item Option
 *
 * Remove an option from a rubric item.
 */
export const deleteRubricItemOptionMutation = (
  options?: Partial<Options<DeleteRubricItemOptionData>>,
): UseMutationOptions<
  DeleteRubricItemOptionResponse,
  DeleteRubricItemOptionError,
  Options<DeleteRubricItemOptionData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteRubricItemOptionResponse,
    DeleteRubricItemOptionError,
    Options<DeleteRubricItemOptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteRubricItemOption({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Update Rubric Item Option
 *
 * Update a rubric item option.
 *
 * Note: Returns 400 instead of 404 when option is not found because the domain raises
 * undifferentiable ValueError for both validation errors and missing options.
 */
export const updateRubricItemOptionMutation = (
  options?: Partial<Options<UpdateRubricItemOptionData>>,
): UseMutationOptions<
  UpdateRubricItemOptionResponse,
  UpdateRubricItemOptionError,
  Options<UpdateRubricItemOptionData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateRubricItemOptionResponse,
    UpdateRubricItemOptionError,
    Options<UpdateRubricItemOptionData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateRubricItemOption({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Reorder Rubric Item Options
 *
 * Reorder options for a rubric item.
 */
export const reorderRubricItemOptionsMutation = (
  options?: Partial<Options<ReorderRubricItemOptionsData>>,
): UseMutationOptions<
  ReorderRubricItemOptionsResponse,
  ReorderRubricItemOptionsError,
  Options<ReorderRubricItemOptionsData>
> => {
  const mutationOptions: UseMutationOptions<
    ReorderRubricItemOptionsResponse,
    ReorderRubricItemOptionsError,
    Options<ReorderRubricItemOptionsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await reorderRubricItemOptions({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listAssignmentsQueryKey = (options: Options<ListAssignmentsData>) =>
  createQueryKey("listAssignments", options)

/**
 * List Assignments
 *
 * List all assignments for a course, including their current state and aggregate counts.
 */
export const listAssignmentsOptions = (options: Options<ListAssignmentsData>) =>
  queryOptions<
    ListAssignmentsResponse,
    ListAssignmentsError,
    ListAssignmentsResponse,
    ReturnType<typeof listAssignmentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAssignmentsQueryKey(options),
  })

export const listAssignmentsInfiniteQueryKey = (
  options: Options<ListAssignmentsData>,
): QueryKey<Options<ListAssignmentsData>> => createQueryKey("listAssignments", options, true)

/**
 * List Assignments
 *
 * List all assignments for a course, including their current state and aggregate counts.
 */
export const listAssignmentsInfiniteOptions = (options: Options<ListAssignmentsData>) =>
  infiniteQueryOptions<
    ListAssignmentsResponse,
    ListAssignmentsError,
    InfiniteData<ListAssignmentsResponse>,
    QueryKey<Options<ListAssignmentsData>>,
    number | Pick<QueryKey<Options<ListAssignmentsData>>[0], "body" | "headers" | "path" | "query">
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListAssignmentsData>>[0], "body" | "headers" | "path" | "query"> =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  page: pageParam,
                },
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listAssignments({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        })
        return data
      },
      queryKey: listAssignmentsInfiniteQueryKey(options),
    },
  )

/**
 * Create Assignment
 *
 * Create a new assignment for a course with specified metadata and scheduling.
 */
export const createAssignmentMutation = (
  options?: Partial<Options<CreateAssignmentData>>,
): UseMutationOptions<CreateAssignmentResponse, CreateAssignmentError, Options<CreateAssignmentData>> => {
  const mutationOptions: UseMutationOptions<
    CreateAssignmentResponse,
    CreateAssignmentError,
    Options<CreateAssignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createAssignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Assignment
 *
 * Delete an assignment and all associated allocations, reviews, and drafts.
 */
export const deleteAssignmentMutation = (
  options?: Partial<Options<DeleteAssignmentData>>,
): UseMutationOptions<DeleteAssignmentResponse, DeleteAssignmentError, Options<DeleteAssignmentData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteAssignmentResponse,
    DeleteAssignmentError,
    Options<DeleteAssignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteAssignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAssignmentQueryKey = (options: Options<GetAssignmentData>) => createQueryKey("getAssignment", options)

/**
 * Get Assignment
 *
 * Retrieve detailed information for an assignment.
 *
 * This endpoint returns the full assignment aggregate, which may expose unnecessary data.
 * For most cases, use role-specific drill-in endpoints like /my-allocations, /my-received-reviews, or /my-written-reviews instead.
 */
export const getAssignmentOptions = (options: Options<GetAssignmentData>) =>
  queryOptions<
    GetAssignmentResponse,
    GetAssignmentError,
    GetAssignmentResponse,
    ReturnType<typeof getAssignmentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssignment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAssignmentQueryKey(options),
  })

/**
 * Update Assignment
 *
 * Update assignment metadata such as title, deadlines, and late submission policies.
 */
export const updateAssignmentMutation = (
  options?: Partial<Options<UpdateAssignmentData>>,
): UseMutationOptions<UpdateAssignmentResponse, UpdateAssignmentError, Options<UpdateAssignmentData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssignmentResponse,
    UpdateAssignmentError,
    Options<UpdateAssignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAssignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAssignmentSummaryQueryKey = (options: Options<GetAssignmentSummaryData>) =>
  createQueryKey("getAssignmentSummary", options)

/**
 * Get Assignment Summary
 *
 * Retrieve a lightweight assignment summary with aggregate counts.
 */
export const getAssignmentSummaryOptions = (options: Options<GetAssignmentSummaryData>) =>
  queryOptions<
    GetAssignmentSummaryResponse,
    GetAssignmentSummaryError,
    GetAssignmentSummaryResponse,
    ReturnType<typeof getAssignmentSummaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssignmentSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAssignmentSummaryQueryKey(options),
  })

export const listAllocationsQueryKey = (options: Options<ListAllocationsData>) =>
  createQueryKey("listAllocations", options)

/**
 * List Allocations
 *
 * Get allocations for an assignment with role-based scoping.
 */
export const listAllocationsOptions = (options: Options<ListAllocationsData>) =>
  queryOptions<
    ListAllocationsResponse,
    ListAllocationsError,
    ListAllocationsResponse,
    ReturnType<typeof listAllocationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listAllocationsQueryKey(options),
  })

/**
 * Open Assignment
 *
 * Open an assignment by snapshotting rubric and generating allocations.
 */
export const openAssignmentMutation = (
  options?: Partial<Options<OpenAssignmentData>>,
): UseMutationOptions<OpenAssignmentResponse, OpenAssignmentError, Options<OpenAssignmentData>> => {
  const mutationOptions: UseMutationOptions<
    OpenAssignmentResponse,
    OpenAssignmentError,
    Options<OpenAssignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await openAssignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Close Assignment
 *
 * Close an assignment via semantic close hook.
 */
export const closeAssignmentMutation = (
  options?: Partial<Options<CloseAssignmentData>>,
): UseMutationOptions<CloseAssignmentResponse, CloseAssignmentError, Options<CloseAssignmentData>> => {
  const mutationOptions: UseMutationOptions<
    CloseAssignmentResponse,
    CloseAssignmentError,
    Options<CloseAssignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await closeAssignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Publish Assignment
 *
 * Publish an assignment to reveal reviews.
 */
export const publishAssignmentMutation = (
  options?: Partial<Options<PublishAssignmentData>>,
): UseMutationOptions<PublishAssignmentResponse, PublishAssignmentError, Options<PublishAssignmentData>> => {
  const mutationOptions: UseMutationOptions<
    PublishAssignmentResponse,
    PublishAssignmentError,
    Options<PublishAssignmentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await publishAssignment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listMyAllocationsQueryKey = (options: Options<ListMyAllocationsData>) =>
  createQueryKey("listMyAllocations", options)

/**
 * List My Allocations
 *
 * Get the current user's assigned allocations for review.
 */
export const listMyAllocationsOptions = (options: Options<ListMyAllocationsData>) =>
  queryOptions<
    ListMyAllocationsResponse,
    ListMyAllocationsError,
    ListMyAllocationsResponse,
    ReturnType<typeof listMyAllocationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyAllocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listMyAllocationsQueryKey(options),
  })

export const listMyReceivedReviewsQueryKey = (options: Options<ListMyReceivedReviewsData>) =>
  createQueryKey("listMyReceivedReviews", options)

/**
 * List My Received Reviews
 *
 * Get reviews received by the current user with anonymized reviewer identities.
 *
 * Returns reviews where the reviewer identity is masked with a pseudonym to
 * maintain single-blind anonymity. Authors never see the real reviewer identity.
 * If reviews are unpublished, only the total count is returned.
 */
export const listMyReceivedReviewsOptions = (options: Options<ListMyReceivedReviewsData>) =>
  queryOptions<
    ListMyReceivedReviewsResponse,
    ListMyReceivedReviewsError,
    ListMyReceivedReviewsResponse,
    ReturnType<typeof listMyReceivedReviewsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyReceivedReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listMyReceivedReviewsQueryKey(options),
  })

export const listMyWrittenReviewsQueryKey = (options: Options<ListMyWrittenReviewsData>) =>
  createQueryKey("listMyWrittenReviews", options)

/**
 * List My Written Reviews
 *
 * Get reviews written by the current user.
 */
export const listMyWrittenReviewsOptions = (options: Options<ListMyWrittenReviewsData>) =>
  queryOptions<
    ListMyWrittenReviewsResponse,
    ListMyWrittenReviewsError,
    ListMyWrittenReviewsResponse,
    ReturnType<typeof listMyWrittenReviewsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyWrittenReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listMyWrittenReviewsQueryKey(options),
  })

export const listReviewsQueryKey = (options: Options<ListReviewsData>) => createQueryKey("listReviews", options)

/**
 * List Reviews
 *
 * Get all submitted reviews for an assignment (staff-only visibility).
 */
export const listReviewsOptions = (options: Options<ListReviewsData>) =>
  queryOptions<ListReviewsResponse, ListReviewsError, ListReviewsResponse, ReturnType<typeof listReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listReviewsQueryKey(options),
  })

export const getReviewDraftQueryKey = (options: Options<GetReviewDraftData>) =>
  createQueryKey("getReviewDraft", options)

/**
 * Get Review Draft
 *
 * Fetch a saved draft for an allocation.
 *
 * Returns the draft if it exists, or null if no draft has been saved yet.
 * Students can only access their own drafts; instructors can view all drafts.
 */
export const getReviewDraftOptions = (options: Options<GetReviewDraftData>) =>
  queryOptions<
    GetReviewDraftResponse,
    GetReviewDraftError,
    GetReviewDraftResponse,
    ReturnType<typeof getReviewDraftQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReviewDraft({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getReviewDraftQueryKey(options),
  })

/**
 * Save Review Draft
 *
 * Save a draft review for an allocation, allowing reviewers to work incrementally.
 */
export const saveReviewDraftMutation = (
  options?: Partial<Options<SaveReviewDraftData>>,
): UseMutationOptions<SaveReviewDraftResponse, SaveReviewDraftError, Options<SaveReviewDraftData>> => {
  const mutationOptions: UseMutationOptions<
    SaveReviewDraftResponse,
    SaveReviewDraftError,
    Options<SaveReviewDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveReviewDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Submit Review
 *
 * Submit a finalized review for an allocation, marking it complete with timestamp.
 */
export const submitReviewMutation = (
  options?: Partial<Options<SubmitReviewData>>,
): UseMutationOptions<SubmitReviewResponse, SubmitReviewError, Options<SubmitReviewData>> => {
  const mutationOptions: UseMutationOptions<SubmitReviewResponse, SubmitReviewError, Options<SubmitReviewData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Submitted Review
 *
 * Delete a submitted peer or intra-team review from an allocation.
 */
export const deleteSubmittedReviewMutation = (
  options?: Partial<Options<DeleteSubmittedReviewData>>,
): UseMutationOptions<
  DeleteSubmittedReviewResponse,
  DeleteSubmittedReviewError,
  Options<DeleteSubmittedReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSubmittedReviewResponse,
    DeleteSubmittedReviewError,
    Options<DeleteSubmittedReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteSubmittedReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Submit Staff Review
 *
 * Submit a staff-authored review for a student or team.
 */
export const submitStaffReviewMutation = (
  options?: Partial<Options<SubmitStaffReviewData>>,
): UseMutationOptions<SubmitStaffReviewResponse, SubmitStaffReviewError, Options<SubmitStaffReviewData>> => {
  const mutationOptions: UseMutationOptions<
    SubmitStaffReviewResponse,
    SubmitStaffReviewError,
    Options<SubmitStaffReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitStaffReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getAssignmentScoringConfigQueryKey = (options: Options<GetAssignmentScoringConfigData>) =>
  createQueryKey("getAssignmentScoringConfig", options)

/**
 * Get Scoring Config
 *
 * Return resolved assignment scoring configuration including defaults.
 */
export const getAssignmentScoringConfigOptions = (options: Options<GetAssignmentScoringConfigData>) =>
  queryOptions<
    GetAssignmentScoringConfigResponse,
    GetAssignmentScoringConfigError,
    GetAssignmentScoringConfigResponse,
    ReturnType<typeof getAssignmentScoringConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAssignmentScoringConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getAssignmentScoringConfigQueryKey(options),
  })

/**
 * Update Scoring Config
 *
 * Update assignment scoring pipeline configuration.
 */
export const updateAssignmentScoringConfigMutation = (
  options?: Partial<Options<UpdateAssignmentScoringConfigData>>,
): UseMutationOptions<
  UpdateAssignmentScoringConfigResponse,
  UpdateAssignmentScoringConfigError,
  Options<UpdateAssignmentScoringConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateAssignmentScoringConfigResponse,
    UpdateAssignmentScoringConfigError,
    Options<UpdateAssignmentScoringConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateAssignmentScoringConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const previewAssignmentScoresQueryKey = (options: Options<PreviewAssignmentScoresData>) =>
  createQueryKey("previewAssignmentScores", options)

/**
 * Preview Scores
 *
 * Compute non-materialized preview scores for all assignment reviewees.
 */
export const previewAssignmentScoresOptions = (options: Options<PreviewAssignmentScoresData>) =>
  queryOptions<
    PreviewAssignmentScoresResponse,
    PreviewAssignmentScoresError,
    PreviewAssignmentScoresResponse,
    ReturnType<typeof previewAssignmentScoresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await previewAssignmentScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: previewAssignmentScoresQueryKey(options),
  })

export const getRevieweeScoreQueryKey = (options: Options<GetRevieweeScoreData>) =>
  createQueryKey("getRevieweeScore", options)

/**
 * Get Published Score For Reviewee
 *
 * Return the published materialized score for a reviewee.
 */
export const getRevieweeScoreOptions = (options: Options<GetRevieweeScoreData>) =>
  queryOptions<
    GetRevieweeScoreResponse,
    GetRevieweeScoreError,
    GetRevieweeScoreResponse,
    ReturnType<typeof getRevieweeScoreQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRevieweeScore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRevieweeScoreQueryKey(options),
  })

export const getRevieweeTeamScoreQueryKey = (options: Options<GetRevieweeTeamScoreData>) =>
  createQueryKey("getRevieweeTeamScore", options)

/**
 * Get Published Score For Reviewee Team
 *
 * Return the published materialized score for a reviewee team.
 */
export const getRevieweeTeamScoreOptions = (options: Options<GetRevieweeTeamScoreData>) =>
  queryOptions<
    GetRevieweeTeamScoreResponse,
    GetRevieweeTeamScoreError,
    GetRevieweeTeamScoreResponse,
    ReturnType<typeof getRevieweeTeamScoreQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRevieweeTeamScore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getRevieweeTeamScoreQueryKey(options),
  })

export const getReviewerParticipationQueryKey = (options: Options<GetReviewerParticipationData>) =>
  createQueryKey("getReviewerParticipation", options)

/**
 * Get Reviewer Participation
 *
 * Retrieve reviewer participation metrics including completion rate and review counts.
 */
export const getReviewerParticipationOptions = (options: Options<GetReviewerParticipationData>) =>
  queryOptions<
    GetReviewerParticipationResponse,
    GetReviewerParticipationError,
    GetReviewerParticipationResponse,
    ReturnType<typeof getReviewerParticipationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReviewerParticipation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getReviewerParticipationQueryKey(options),
  })

export const getReviewerTeamParticipationQueryKey = (options: Options<GetReviewerTeamParticipationData>) =>
  createQueryKey("getReviewerTeamParticipation", options)

/**
 * Get Reviewer Team Participation
 *
 * Retrieve participation metrics for a reviewer team.
 */
export const getReviewerTeamParticipationOptions = (options: Options<GetReviewerTeamParticipationData>) =>
  queryOptions<
    GetReviewerTeamParticipationResponse,
    GetReviewerTeamParticipationError,
    GetReviewerTeamParticipationResponse,
    ReturnType<typeof getReviewerTeamParticipationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getReviewerTeamParticipation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getReviewerTeamParticipationQueryKey(options),
  })

/**
 * Assign Late Joiner
 *
 * Assign allocations for a late-joining reviewer after assignment has opened.
 */
export const assignLateJoinerMutation = (
  options?: Partial<Options<AssignLateJoinerData>>,
): UseMutationOptions<AssignLateJoinerResponse, AssignLateJoinerError, Options<AssignLateJoinerData>> => {
  const mutationOptions: UseMutationOptions<
    AssignLateJoinerResponse,
    AssignLateJoinerError,
    Options<AssignLateJoinerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assignLateJoiner({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Assign Late Joiner Team
 *
 * Assign allocations for a late-joining reviewer team.
 */
export const assignLateJoinerTeamMutation = (
  options?: Partial<Options<AssignLateJoinerTeamData>>,
): UseMutationOptions<AssignLateJoinerTeamResponse, AssignLateJoinerTeamError, Options<AssignLateJoinerTeamData>> => {
  const mutationOptions: UseMutationOptions<
    AssignLateJoinerTeamResponse,
    AssignLateJoinerTeamError,
    Options<AssignLateJoinerTeamData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await assignLateJoinerTeam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Add Late Author
 *
 * Queue a late assignment submitter for allocation handling and review assignment.
 */
export const addLateAuthorMutation = (
  options?: Partial<Options<AddLateAuthorData>>,
): UseMutationOptions<AddLateAuthorResponse, AddLateAuthorError, Options<AddLateAuthorData>> => {
  const mutationOptions: UseMutationOptions<AddLateAuthorResponse, AddLateAuthorError, Options<AddLateAuthorData>> = {
    mutationFn: async (fnOptions) => {
      const { data } = await addLateAuthor({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const recommendExtraTargetsQueryKey = (options: Options<RecommendExtraTargetsData>) =>
  createQueryKey("recommendExtraTargets", options)

/**
 * Recommend Extra Targets
 *
 * Recommend extra review targets for a reviewer who has completed required reviews.
 */
export const recommendExtraTargetsOptions = (options: Options<RecommendExtraTargetsData>) =>
  queryOptions<
    RecommendExtraTargetsResponse,
    RecommendExtraTargetsError,
    RecommendExtraTargetsResponse,
    ReturnType<typeof recommendExtraTargetsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recommendExtraTargets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: recommendExtraTargetsQueryKey(options),
  })

export const recommendExtraTargetsForReviewerTeamQueryKey = (
  options: Options<RecommendExtraTargetsForReviewerTeamData>,
) => createQueryKey("recommendExtraTargetsForReviewerTeam", options)

/**
 * Recommend Extra Targets For Reviewer Team
 *
 * Recommend extra review targets for a reviewer team.
 */
export const recommendExtraTargetsForReviewerTeamOptions = (
  options: Options<RecommendExtraTargetsForReviewerTeamData>,
) =>
  queryOptions<
    RecommendExtraTargetsForReviewerTeamResponse,
    RecommendExtraTargetsForReviewerTeamError,
    RecommendExtraTargetsForReviewerTeamResponse,
    ReturnType<typeof recommendExtraTargetsForReviewerTeamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await recommendExtraTargetsForReviewerTeam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: recommendExtraTargetsForReviewerTeamQueryKey(options),
  })

export const listPublishedAssignmentScoresQueryKey = (options: Options<ListPublishedAssignmentScoresData>) =>
  createQueryKey("listPublishedAssignmentScores", options)

/**
 * List Published Scores
 *
 * Return published scores keyed by reviewee principal.
 *
 * For inter-team assignments the key is the reviewee team ID;
 * for other review types the key is the reviewee user ID.
 */
export const listPublishedAssignmentScoresOptions = (options: Options<ListPublishedAssignmentScoresData>) =>
  queryOptions<
    ListPublishedAssignmentScoresResponse,
    ListPublishedAssignmentScoresError,
    ListPublishedAssignmentScoresResponse,
    ReturnType<typeof listPublishedAssignmentScoresQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listPublishedAssignmentScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listPublishedAssignmentScoresQueryKey(options),
  })

export const getPublishedAssignmentScoreQueryKey = (options: Options<GetPublishedAssignmentScoreData>) =>
  createQueryKey("getPublishedAssignmentScore", options)

/**
 * Get Published Score
 *
 * Get one materialized published score row for an assignment user.
 */
export const getPublishedAssignmentScoreOptions = (options: Options<GetPublishedAssignmentScoreData>) =>
  queryOptions<
    GetPublishedAssignmentScoreResponse,
    GetPublishedAssignmentScoreError,
    GetPublishedAssignmentScoreResponse,
    ReturnType<typeof getPublishedAssignmentScoreQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPublishedAssignmentScore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getPublishedAssignmentScoreQueryKey(options),
  })

export const getMyPublishedAssignmentScoreQueryKey = (options: Options<GetMyPublishedAssignmentScoreData>) =>
  createQueryKey("getMyPublishedAssignmentScore", options)

/**
 * Get My Score
 *
 * Get the current student's materialized published score for an assignment.
 */
export const getMyPublishedAssignmentScoreOptions = (options: Options<GetMyPublishedAssignmentScoreData>) =>
  queryOptions<
    GetMyPublishedAssignmentScoreResponse,
    GetMyPublishedAssignmentScoreError,
    GetMyPublishedAssignmentScoreResponse,
    ReturnType<typeof getMyPublishedAssignmentScoreQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyPublishedAssignmentScore({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getMyPublishedAssignmentScoreQueryKey(options),
  })

export const exportAssignmentScoresQueryKey = (options: Options<ExportAssignmentScoresData>) =>
  createQueryKey("exportAssignmentScores", options)

/**
 * Export Scores
 *
 * Export assignment scores as CSV.
 *
 * Generates a CSV with per-student gradebook data including per-criterion means,
 * overall scores, and review counts. Supports anonymization toggle.
 */
export const exportAssignmentScoresOptions = (options: Options<ExportAssignmentScoresData>) =>
  queryOptions<unknown, ExportAssignmentScoresError, unknown, ReturnType<typeof exportAssignmentScoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportAssignmentScores({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportAssignmentScoresQueryKey(options),
  })

export const exportAssignmentReviewsQueryKey = (options: Options<ExportAssignmentReviewsData>) =>
  createQueryKey("exportAssignmentReviews", options)

/**
 * Export Reviews
 *
 * Export assignment reviews as CSV with normalized rubric-item columns.
 *
 * One row per allocation (including allocations without a submitted review).
 * Rubric answers are expanded into individual columns instead of JSON blobs.
 * Supports anonymization toggle with reviewer pseudonyms.
 */
export const exportAssignmentReviewsOptions = (options: Options<ExportAssignmentReviewsData>) =>
  queryOptions<unknown, ExportAssignmentReviewsError, unknown, ReturnType<typeof exportAssignmentReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportAssignmentReviews({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportAssignmentReviewsQueryKey(options),
  })

export const exportAssignmentAllocationsQueryKey = (options: Options<ExportAssignmentAllocationsData>) =>
  createQueryKey("exportAssignmentAllocations", options)

/**
 * Export Allocations
 *
 * Export assignment allocations as CSV.
 *
 * .. deprecated::
 * Use the reviews export instead, which now includes all allocations
 * with normalized rubric-item answer columns.
 *
 * @deprecated
 */
export const exportAssignmentAllocationsOptions = (options: Options<ExportAssignmentAllocationsData>) =>
  queryOptions<
    unknown,
    ExportAssignmentAllocationsError,
    unknown,
    ReturnType<typeof exportAssignmentAllocationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportAssignmentAllocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: exportAssignmentAllocationsQueryKey(options),
  })

export const listTeamAllocationsQueryKey = (options: Options<ListTeamAllocationsData>) =>
  createQueryKey("listTeamAllocations", options)

/**
 * List Team Allocations
 *
 * List all inter-team allocations for an assignment (staff only).
 */
export const listTeamAllocationsOptions = (options: Options<ListTeamAllocationsData>) =>
  queryOptions<
    ListTeamAllocationsResponse,
    ListTeamAllocationsError,
    ListTeamAllocationsResponse,
    ReturnType<typeof listTeamAllocationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listTeamAllocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listTeamAllocationsQueryKey(options),
  })

export const getTeamReviewQueryKey = (options: Options<GetTeamReviewData>) => createQueryKey("getTeamReview", options)

/**
 * Get Team Review
 *
 * Get team-review state for an inter-team allocation.
 */
export const getTeamReviewOptions = (options: Options<GetTeamReviewData>) =>
  queryOptions<
    GetTeamReviewResponse,
    GetTeamReviewError,
    GetTeamReviewResponse,
    ReturnType<typeof getTeamReviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamReview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getTeamReviewQueryKey(options),
  })

/**
 * Release Team Review Lock
 *
 * Release the edit lock on a team review.
 */
export const releaseTeamReviewLockMutation = (
  options?: Partial<Options<ReleaseTeamReviewLockData>>,
): UseMutationOptions<
  ReleaseTeamReviewLockResponse,
  ReleaseTeamReviewLockError,
  Options<ReleaseTeamReviewLockData>
> => {
  const mutationOptions: UseMutationOptions<
    ReleaseTeamReviewLockResponse,
    ReleaseTeamReviewLockError,
    Options<ReleaseTeamReviewLockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await releaseTeamReviewLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Acquire Team Review Lock
 *
 * Acquire the edit lock on a team review.
 */
export const acquireTeamReviewLockMutation = (
  options?: Partial<Options<AcquireTeamReviewLockData>>,
): UseMutationOptions<
  AcquireTeamReviewLockResponse,
  AcquireTeamReviewLockError,
  Options<AcquireTeamReviewLockData>
> => {
  const mutationOptions: UseMutationOptions<
    AcquireTeamReviewLockResponse,
    AcquireTeamReviewLockError,
    Options<AcquireTeamReviewLockData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await acquireTeamReviewLock({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Save Team Review Draft
 *
 * Save a draft for a team review. Requires the edit lock.
 */
export const saveTeamReviewDraftMutation = (
  options?: Partial<Options<SaveTeamReviewDraftData>>,
): UseMutationOptions<SaveTeamReviewDraftResponse, SaveTeamReviewDraftError, Options<SaveTeamReviewDraftData>> => {
  const mutationOptions: UseMutationOptions<
    SaveTeamReviewDraftResponse,
    SaveTeamReviewDraftError,
    Options<SaveTeamReviewDraftData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await saveTeamReviewDraft({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Submit Team Review
 *
 * Submit a team review.
 */
export const submitTeamReviewMutation = (
  options?: Partial<Options<SubmitTeamReviewData>>,
): UseMutationOptions<SubmitTeamReviewResponse, SubmitTeamReviewError, Options<SubmitTeamReviewData>> => {
  const mutationOptions: UseMutationOptions<
    SubmitTeamReviewResponse,
    SubmitTeamReviewError,
    Options<SubmitTeamReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await submitTeamReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Unsubmit Team Review
 *
 * Revert a submitted team review to draft state.
 */
export const unsubmitTeamReviewMutation = (
  options?: Partial<Options<UnsubmitTeamReviewData>>,
): UseMutationOptions<UnsubmitTeamReviewResponse, UnsubmitTeamReviewError, Options<UnsubmitTeamReviewData>> => {
  const mutationOptions: UseMutationOptions<
    UnsubmitTeamReviewResponse,
    UnsubmitTeamReviewError,
    Options<UnsubmitTeamReviewData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await unsubmitTeamReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Enroll Mock Students
 *
 * Enroll configured mock students into a course (admin-only).
 */
export const adminEnrollMockStudentsMutation = (
  options?: Partial<Options<AdminEnrollMockStudentsData>>,
): UseMutationOptions<
  AdminEnrollMockStudentsResponse,
  AdminEnrollMockStudentsError,
  Options<AdminEnrollMockStudentsData>
> => {
  const mutationOptions: UseMutationOptions<
    AdminEnrollMockStudentsResponse,
    AdminEnrollMockStudentsError,
    Options<AdminEnrollMockStudentsData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await adminEnrollMockStudents({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listLtiIssuersQueryKey = (options?: Options<ListLtiIssuersData>) =>
  createQueryKey("listLtiIssuers", options)

/**
 * List Issuers
 *
 * List all LTI issuers.
 */
export const listLtiIssuersOptions = (options?: Options<ListLtiIssuersData>) =>
  queryOptions<
    ListLtiIssuersResponse,
    ListLtiIssuersError,
    ListLtiIssuersResponse,
    ReturnType<typeof listLtiIssuersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLtiIssuers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listLtiIssuersQueryKey(options),
  })

/**
 * Create Issuer
 *
 * Create a new LTI issuer.
 */
export const createLtiIssuerMutation = (
  options?: Partial<Options<CreateLtiIssuerData>>,
): UseMutationOptions<CreateLtiIssuerResponse, CreateLtiIssuerError, Options<CreateLtiIssuerData>> => {
  const mutationOptions: UseMutationOptions<
    CreateLtiIssuerResponse,
    CreateLtiIssuerError,
    Options<CreateLtiIssuerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createLtiIssuer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Issuer
 *
 * Delete an LTI issuer.
 */
export const deleteLtiIssuerMutation = (
  options?: Partial<Options<DeleteLtiIssuerData>>,
): UseMutationOptions<DeleteLtiIssuerResponse, DeleteLtiIssuerError, Options<DeleteLtiIssuerData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteLtiIssuerResponse,
    DeleteLtiIssuerError,
    Options<DeleteLtiIssuerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteLtiIssuer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getLtiIssuerQueryKey = (options: Options<GetLtiIssuerData>) => createQueryKey("getLtiIssuer", options)

/**
 * Get Issuer
 *
 * Get an LTI issuer by ID.
 */
export const getLtiIssuerOptions = (options: Options<GetLtiIssuerData>) =>
  queryOptions<GetLtiIssuerResponse, GetLtiIssuerError, GetLtiIssuerResponse, ReturnType<typeof getLtiIssuerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLtiIssuer({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLtiIssuerQueryKey(options),
  })

/**
 * Update Issuer
 *
 * Update an LTI issuer.
 */
export const updateLtiIssuerMutation = (
  options?: Partial<Options<UpdateLtiIssuerData>>,
): UseMutationOptions<UpdateLtiIssuerResponse, UpdateLtiIssuerError, Options<UpdateLtiIssuerData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateLtiIssuerResponse,
    UpdateLtiIssuerError,
    Options<UpdateLtiIssuerData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLtiIssuer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listLtiClientConfigsQueryKey = (options: Options<ListLtiClientConfigsData>) =>
  createQueryKey("listLtiClientConfigs", options)

/**
 * List Client Configs
 *
 * List all client configurations for an issuer.
 */
export const listLtiClientConfigsOptions = (options: Options<ListLtiClientConfigsData>) =>
  queryOptions<
    ListLtiClientConfigsResponse,
    ListLtiClientConfigsError,
    ListLtiClientConfigsResponse,
    ReturnType<typeof listLtiClientConfigsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLtiClientConfigs({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listLtiClientConfigsQueryKey(options),
  })

/**
 * Create Client Config
 *
 * Create a new client configuration for an issuer.
 */
export const createLtiClientConfigMutation = (
  options?: Partial<Options<CreateLtiClientConfigData>>,
): UseMutationOptions<
  CreateLtiClientConfigResponse,
  CreateLtiClientConfigError,
  Options<CreateLtiClientConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateLtiClientConfigResponse,
    CreateLtiClientConfigError,
    Options<CreateLtiClientConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createLtiClientConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Client Config
 *
 * Delete a client configuration.
 */
export const deleteLtiClientConfigMutation = (
  options?: Partial<Options<DeleteLtiClientConfigData>>,
): UseMutationOptions<
  DeleteLtiClientConfigResponse,
  DeleteLtiClientConfigError,
  Options<DeleteLtiClientConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteLtiClientConfigResponse,
    DeleteLtiClientConfigError,
    Options<DeleteLtiClientConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteLtiClientConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getLtiClientConfigQueryKey = (options: Options<GetLtiClientConfigData>) =>
  createQueryKey("getLtiClientConfig", options)

/**
 * Get Client Config
 *
 * Get a client configuration by ID.
 */
export const getLtiClientConfigOptions = (options: Options<GetLtiClientConfigData>) =>
  queryOptions<
    GetLtiClientConfigResponse,
    GetLtiClientConfigError,
    GetLtiClientConfigResponse,
    ReturnType<typeof getLtiClientConfigQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLtiClientConfig({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLtiClientConfigQueryKey(options),
  })

/**
 * Update Client Config
 *
 * Update a client configuration.
 */
export const updateLtiClientConfigMutation = (
  options?: Partial<Options<UpdateLtiClientConfigData>>,
): UseMutationOptions<
  UpdateLtiClientConfigResponse,
  UpdateLtiClientConfigError,
  Options<UpdateLtiClientConfigData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateLtiClientConfigResponse,
    UpdateLtiClientConfigError,
    Options<UpdateLtiClientConfigData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLtiClientConfig({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listLtiDeploymentsQueryKey = (options: Options<ListLtiDeploymentsData>) =>
  createQueryKey("listLtiDeployments", options)

/**
 * List Deployments
 *
 * List all deployments for a client configuration.
 */
export const listLtiDeploymentsOptions = (options: Options<ListLtiDeploymentsData>) =>
  queryOptions<
    ListLtiDeploymentsResponse,
    ListLtiDeploymentsError,
    ListLtiDeploymentsResponse,
    ReturnType<typeof listLtiDeploymentsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLtiDeployments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listLtiDeploymentsQueryKey(options),
  })

/**
 * Add Deployment
 *
 * Add a deployment to a client configuration.
 */
export const addLtiDeploymentMutation = (
  options?: Partial<Options<AddLtiDeploymentData>>,
): UseMutationOptions<AddLtiDeploymentResponse, AddLtiDeploymentError, Options<AddLtiDeploymentData>> => {
  const mutationOptions: UseMutationOptions<
    AddLtiDeploymentResponse,
    AddLtiDeploymentError,
    Options<AddLtiDeploymentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addLtiDeployment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Remove Deployment
 *
 * Remove a deployment.
 */
export const removeLtiDeploymentMutation = (
  options?: Partial<Options<RemoveLtiDeploymentData>>,
): UseMutationOptions<RemoveLtiDeploymentResponse, RemoveLtiDeploymentError, Options<RemoveLtiDeploymentData>> => {
  const mutationOptions: UseMutationOptions<
    RemoveLtiDeploymentResponse,
    RemoveLtiDeploymentError,
    Options<RemoveLtiDeploymentData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeLtiDeployment({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const listLtiToolKeysQueryKey = (options?: Options<ListLtiToolKeysData>) =>
  createQueryKey("listLtiToolKeys", options)

/**
 * List Tool Keys
 *
 * List all LTI tool keys.
 */
export const listLtiToolKeysOptions = (options?: Options<ListLtiToolKeysData>) =>
  queryOptions<
    ListLtiToolKeysResponse,
    ListLtiToolKeysError,
    ListLtiToolKeysResponse,
    ReturnType<typeof listLtiToolKeysQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listLtiToolKeys({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: listLtiToolKeysQueryKey(options),
  })

/**
 * Create Tool Key
 *
 * Create a new LTI tool key.
 */
export const createLtiToolKeyMutation = (
  options?: Partial<Options<CreateLtiToolKeyData>>,
): UseMutationOptions<CreateLtiToolKeyResponse, CreateLtiToolKeyError, Options<CreateLtiToolKeyData>> => {
  const mutationOptions: UseMutationOptions<
    CreateLtiToolKeyResponse,
    CreateLtiToolKeyError,
    Options<CreateLtiToolKeyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createLtiToolKey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

/**
 * Delete Tool Key
 *
 * Delete an LTI tool key.
 */
export const deleteLtiToolKeyMutation = (
  options?: Partial<Options<DeleteLtiToolKeyData>>,
): UseMutationOptions<DeleteLtiToolKeyResponse, DeleteLtiToolKeyError, Options<DeleteLtiToolKeyData>> => {
  const mutationOptions: UseMutationOptions<
    DeleteLtiToolKeyResponse,
    DeleteLtiToolKeyError,
    Options<DeleteLtiToolKeyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteLtiToolKey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}

export const getLtiToolKeyQueryKey = (options: Options<GetLtiToolKeyData>) => createQueryKey("getLtiToolKey", options)

/**
 * Get Tool Key
 *
 * Get an LTI tool key by ID.
 */
export const getLtiToolKeyOptions = (options: Options<GetLtiToolKeyData>) =>
  queryOptions<
    GetLtiToolKeyResponse,
    GetLtiToolKeyError,
    GetLtiToolKeyResponse,
    ReturnType<typeof getLtiToolKeyQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLtiToolKey({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      })
      return data
    },
    queryKey: getLtiToolKeyQueryKey(options),
  })

/**
 * Update Tool Key
 *
 * Update an LTI tool key.
 */
export const updateLtiToolKeyMutation = (
  options?: Partial<Options<UpdateLtiToolKeyData>>,
): UseMutationOptions<UpdateLtiToolKeyResponse, UpdateLtiToolKeyError, Options<UpdateLtiToolKeyData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateLtiToolKeyResponse,
    UpdateLtiToolKeyError,
    Options<UpdateLtiToolKeyData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLtiToolKey({
        ...options,
        ...fnOptions,
        throwOnError: true,
      })
      return data
    },
  }
  return mutationOptions
}
